import React, { useState } from "react";
import AdminPanelAddressBook from "./adminPanelAddressBook.js";
import AdminPanelBankLawyers from "./adminPanelBankLawyers.js";
import AdminPanelBankLawyersOffice from "./adminPanelBankLawyersOffice.js";
import AdminPanelBanks from "./adminPanelBanks.js";
import AdminPanelBanksOld from "./adminPanelBanksOld";
import AdminPanelChecklistLawsuit from "./adminPanelChecklistLawsuit";
import AdminPanelChecklistLawsuitSKD from "./adminPanelCheckListLawsuitSKD.js";
import AdminPanelCourtMailTemplate from "./adminPanelCourtMailTemplates.js";
import AdminPanelCourts from "./adminPanelCourts.js";
import AdminPanelDisc from "./adminPanelDisc";
import AdminPanelExpectedResults from "./adminPanelExpectedResults.js";
import AdminPanelHearingSubject from "./adminPanelHearingSubject.js";
import AdminPanelHolidays from "./adminPanelHolidays.js";
import AdminPanelJudges from "./adminPanelJudges.js";
import AdminPanelJudgesK from "./adminPanelJudgesk.js";
import AdminPanelLawsuitTextList from "./adminPanelLawsuilTextList.js";
import AdminPanelLawsuitText from "./adminPanelLawsuitText.js";
import AdminPanelLawyers from "./adminPanelLawyers.js";
import AdminPanelLeadsLoop from "./adminPanelLeadsLoop.js";
import AdminPanelLeadsLoopChf from "./adminPanelLeadsLoopChf.js";
import AdminPanelLeadSources from "./adminPanelLeadSources.js";
import AdminPanelLeadsPriceList from "./adminPanelLeadsPriceList.js";
import AdminPanelLetters from "./adminPanelLetters";
import AdminPanelLettersAggr from "./adminPanelLettersAggr";
import AdminPanelLettersBank from "./adminPanelLettersBank";
import AdminPanelLettersLawsuit from "./adminPanelLettersLawsuit";
import AdminPanelLettersLawsuitSKD from "./adminPanelLettersLawsuitSKD.js";
import AdminPanelLoopTasks from "./adminPanelLoopTasks.js";
import AdminPanelMailTemplate from "./adminPanelMailTemplate.js";
import AdminPanelMaterials from "./adminPanelMaterials.js";
import AdminPanelMaterialsConsultant from "./adminPanelMaterialsConsultant.js";
import AdminPanelMaterialsConsultantDepartment from "./adminPanelMaterialsConsultantDepartment.js";
import AdminPanelMaterialsDepartment from "./adminPanelMaterialsDepartment.js";
import AdminPanelMaterialsDepartmentSec from "./adminPanelMaterialsDepartmentSec.js";
import AdminPanelMSAPI from "./adminPanelMSAPI.js";
import AdminPanelPackageDesc from "./adminPanelPackageDesc.js";
import AdminPanelPelSubLawyers from "./adminPanelPelSubLawyers.js";
import AdminPanelQuestionsCHF from "./adminPanelQuestionsCHF.js";
import AdminPanelQuestionsSKD from "./adminPanelQuestionsSKD.js";
import AdminPanelReportClients from "./adminPanelReportClients.js";
import AdminPanelResults from "./adminPanelResults.js";
import AdminPanelSellMailTemplate from "./adminPanelSellMailTemplate.js";
import AdminPanelSellSMSTemplate from "./adminPanelSellSMSTemplate.js";
import AdminPanelSellTaskTypes from "./adminPanelSellTaskTypes.js";
import AdminPanelStatuses from "./adminPanelStatuses.js";
import AdminPanelSubstitutes from "./adminPanelSubstitutes.js";
import AdminPanelSupport from "./adminPanelSupport.js";
import AdminPanelTaskTypes from "./adminPanelTaskTypes.js";
import AdminPanelUsers from "./adminPanelUsers.js";
import AdminPanelUsersResults from "./adminPanelUsersResults.js";

const AdminPanel = (props) => {
  const [showUsers, setShowUsers] = useState(false);
  const [showBanks, setShowBanks] = useState(false);
  const [showCourts, setShowCourts] = useState(false);
  const [showSupport, setShowSupport] = useState(false);
  const [showLawyers, setShowLawyers] = useState(false);
  const [showSubstitutes, setShowSubstitutes] = useState(false);
  const [showResults, setShowResults] = useState(false);
  const [showExpectedResults, setShowExpectedResults] = useState(false);
  const [showTasksTypes, setShowTasksTypes] = useState(false);
  const [showSellTasksTypes, setShowSellTasksTypes] = useState(false);
  const [showSellLeadSource, setShowSellLeadSource] = useState(false);
  const [showSellLeadLoop, setShowSellLeadLoop] = useState(false);
  const [showSellMSAPI, setShowSellMSAPI] = useState(false);
  const [showMailTemplates, setShowMailTemplates] = useState(false);
  const [showMaterials, setShowMaterials] = useState(false);
  const [showMaterialsConsultant, setShowMaterialsConsultant] = useState(false);
  const [showMaterialsDepartment, setShowMaterialsDepartment] = useState(false);
  const [showMaterialsDepartmentSec, setShowMaterialsDepartmentSec] =
    useState(false);
  const [
    showMaterialsConsultantDepartment,
    setShowMaterialsConsultantDepartment,
  ] = useState(false);
  const [showCourtMailTemplates, setShowCourtMailTemplates] = useState(false);
  const [showSellMailTemplates, setShowSellMailTemplates] = useState(false);
  const [showSellSMSTemplates, setShowSellSMSTemplates] = useState(false);
  const [showCountHolidays, setShowCountHolidays] = useState(false);
  const [showBankLawyers, setShowBankLawyers] = useState(false);
  const [showBankLawyersOffice, setShowBankLawyersOffice] = useState(false);
  const [showPelSub, setShowPelSub] = useState(false);
  const [showResultSub, setShowResultSub] = useState(false);
  const [showAddressBook, setShowAddresBook] = useState(false);
  const [showPackageDesc, setShowPackageDesc] = useState(false);
  const [showCheckListLawsuit, setShowCheckListLawsuit] = useState(false);
  const [showCheckListLawsuitSKD, setShowCheckListLawsuitSKD] = useState(false);
  const [showLetters, setShowLetters] = useState(false);
  const [showLettersBank, setShowLettersBank] = useState(false);
  const [showLettersAggr, setShowLettersAggr] = useState(false);
  const [showLettersLawsuit, setShowLettersLawsuit] = useState(false);
  const [showLettersLawsuitSKD, setShowLettersLawsuitSKD] = useState(false);
  const [showDisc, setShowDisc] = useState(false);
  const [showBanksOld, setShowBanksOld] = useState(false);
  const [showReportClients, setShowReportClients] = useState(false);
  const [showSellLeadLoopChf, setShowSellLeadLoopChf] = useState(false);
  const [showQuestuonsSKD, setShowQuestionsSKD] = useState(false);
  const [showQuestuonsCHF, setShowQuestionsCHF] = useState(false);
  const [showLText, setShowLText] = useState(false);
  const [showLTextList, setShowLTextList] = useState(false);
  const [showHearingSubject, setShowHearingSubject] = useState(false);
  const [showTaskLoop, setShowTaskLoop] = useState(false);
  const [showJudges, setShowJudges] = useState(false);
  const [showJudgesK, setShowJudgesK] = useState(false);
  const [showPriceList, setShowPriceList] = useState(false);
  const [showStatuses, setShowStatuses] = useState(false);

  const showPelSubF = () => {
    setShowUsers(false);
    setShowBanks(false);
    setShowCourts(false);
    setShowLawyers(false);
    setShowSubstitutes(false);
    setShowResults(false);
    setShowTasksTypes(false);
    setShowSellTasksTypes(false);
    setShowMailTemplates(false);
    setShowSellSMSTemplates(false);
    setShowCountHolidays(false);
    setShowSellLeadSource(false);
    setShowSellMailTemplates(false);
    setShowBankLawyers(false);
    setShowBankLawyersOffice(false);
    setShowCourtMailTemplates(false);
    setShowPelSub(true);
    setShowMaterials(false);
    setShowMaterialsConsultant(false);
    setShowMaterialsDepartment(false);
    setShowMaterialsDepartmentSec(false);
    setShowMaterialsConsultantDepartment(false);
    setShowResultSub(false);
    setShowSellLeadLoop(false);
    setShowSellMSAPI(false);
    setShowAddresBook(false);
    setShowPackageDesc(false);
    setShowCheckListLawsuit(false);
    setShowLetters(false);
    setShowLettersBank(false);
    setShowLettersAggr(false);
    setShowDisc(false);
    setShowBanksOld(false);
    setShowLettersLawsuit(false);
    setShowReportClients(false);
    setShowSellLeadLoopChf(false);
    setShowCheckListLawsuitSKD(false);
    setShowSupport(false);
    setShowQuestionsCHF(false);
    setShowQuestionsSKD(false);
    setShowLettersLawsuitSKD(false);
    setShowLText(false);
    setShowLTextList(false);
    setShowHearingSubject(false);
    setShowTaskLoop(false);
    setShowExpectedResults(false);
    setShowJudges(false);
    setShowJudgesK(false);
    setShowPriceList(false);
    setShowStatuses(false);
  };

  const showSellMailTemplatesF = () => {
    setShowUsers(false);
    setShowBanks(false);
    setShowCourts(false);
    setShowLawyers(false);
    setShowSubstitutes(false);
    setShowResults(false);
    setShowTasksTypes(false);
    setShowSellTasksTypes(false);
    setShowMailTemplates(false);
    setShowCountHolidays(false);
    setShowSellLeadSource(false);
    setShowSellMailTemplates(true);
    setShowSellSMSTemplates(false);
    setShowBankLawyers(false);
    setShowBankLawyersOffice(false);
    setShowCourtMailTemplates(false);
    setShowPelSub(false);
    setShowMaterials(false);
    setShowMaterialsConsultant(false);
    setShowMaterialsDepartment(false);
    setShowMaterialsDepartmentSec(false);
    setShowMaterialsConsultantDepartment(false);
    setShowResultSub(false);
    setShowSellLeadLoop(false);
    setShowSellMSAPI(false);
    setShowAddresBook(false);
    setShowPackageDesc(false);
    setShowCheckListLawsuit(false);
    setShowLetters(false);
    setShowLettersBank(false);
    setShowLettersAggr(false);
    setShowDisc(false);
    setShowBanksOld(false);
    setShowLettersLawsuit(false);
    setShowReportClients(false);
    setShowSellLeadLoopChf(false);
    setShowCheckListLawsuitSKD(false);
    setShowSupport(false);
    setShowQuestionsCHF(false);
    setShowQuestionsSKD(false);
    setShowLettersLawsuitSKD(false);
    setShowLText(false);
    setShowLTextList(false);
    setShowHearingSubject(false);
    setShowTaskLoop(false);
    setShowJudges(false);
    setShowExpectedResults(false);
    setShowJudgesK(false);
    setShowPriceList(false);
    setShowStatuses(false);
  };

  const showSellSMSTemplatesF = () => {
    setShowUsers(false);
    setShowBanks(false);
    setShowCourts(false);
    setShowLawyers(false);
    setShowSubstitutes(false);
    setShowResults(false);
    setShowTasksTypes(false);
    setShowSellTasksTypes(false);
    setShowMailTemplates(false);
    setShowCountHolidays(false);
    setShowSellLeadSource(false);
    setShowSellMailTemplates(false);
    setShowSellSMSTemplates(true);
    setShowBankLawyers(false);
    setShowBankLawyersOffice(false);
    setShowCourtMailTemplates(false);
    setShowPelSub(false);
    setShowMaterials(false);
    setShowMaterialsConsultant(false);
    setShowMaterialsDepartment(false);
    setShowMaterialsConsultantDepartment(false);
    setShowMaterialsDepartmentSec(false);
    setShowResultSub(false);
    setShowSellLeadLoop(false);
    setShowSellMSAPI(false);
    setShowAddresBook(false);
    setShowPackageDesc(false);
    setShowCheckListLawsuit(false);
    setShowLetters(false);
    setShowLettersBank(false);
    setShowLettersAggr(false);
    setShowDisc(false);
    setShowBanksOld(false);
    setShowLettersLawsuit(false);
    setShowReportClients(false);
    setShowSellLeadLoopChf(false);
    setShowCheckListLawsuitSKD(false);
    setShowSupport(false);
    setShowQuestionsCHF(false);
    setShowQuestionsSKD(false);
    setShowLettersLawsuitSKD(false);
    setShowLText(false);
    setShowLTextList(false);
    setShowHearingSubject(false);
    setShowTaskLoop(false);
    setShowJudges(false);
    setShowExpectedResults(false);
    setShowJudgesK(false);
    setShowPriceList(false);
    setShowStatuses(false);
  };

  const showSellCourtMailTemplatesF = () => {
    setShowUsers(false);
    setShowBanks(false);
    setShowCourts(false);
    setShowLawyers(false);
    setShowSubstitutes(false);
    setShowResults(false);
    setShowTasksTypes(false);
    setShowSellTasksTypes(false);
    setShowMailTemplates(false);
    setShowCountHolidays(false);
    setShowSellLeadSource(false);
    setShowSellMailTemplates(false);
    setShowSellSMSTemplates(false);
    setShowCourtMailTemplates(true);
    setShowBankLawyers(false);
    setShowBankLawyersOffice(false);
    setShowPelSub(false);
    setShowMaterials(false);
    setShowMaterialsConsultant(false);
    setShowMaterialsDepartment(false);
    setShowMaterialsConsultantDepartment(false);
    setShowMaterialsDepartmentSec(false);
    setShowResultSub(false);
    setShowSellLeadLoop(false);
    setShowSellMSAPI(false);
    setShowAddresBook(false);
    setShowPackageDesc(false);
    setShowCheckListLawsuit(false);
    setShowLetters(false);
    setShowLettersBank(false);
    setShowLettersAggr(false);
    setShowDisc(false);
    setShowBanksOld(false);
    setShowLettersLawsuit(false);
    setShowReportClients(false);
    setShowSellLeadLoopChf(false);
    setShowCheckListLawsuitSKD(false);
    setShowSupport(false);
    setShowQuestionsCHF(false);
    setShowQuestionsSKD(false);
    setShowLettersLawsuitSKD(false);
    setShowLText(false);
    setShowLTextList(false);
    setShowHearingSubject(false);
    setShowTaskLoop(false);
    setShowExpectedResults(false);
    setShowJudges(false);
    setShowJudgesK(false);
    setShowPriceList(false);
    setShowStatuses(false);
  };

  const showSellLeadSourceF = () => {
    setShowUsers(false);
    setShowBanks(false);
    setShowCourts(false);
    setShowLawyers(false);
    setShowSubstitutes(false);
    setShowResults(false);
    setShowTasksTypes(false);
    setShowSellTasksTypes(false);
    setShowMailTemplates(false);
    setShowCountHolidays(false);
    setShowSellLeadSource(true);
    setShowSellMailTemplates(false);
    setShowSellSMSTemplates(false);
    setShowBankLawyers(false);
    setShowBankLawyersOffice(false);
    setShowCourtMailTemplates(false);
    setShowPelSub(false);
    setShowMaterials(false);
    setShowMaterialsConsultant(false);
    setShowMaterialsDepartment(false);
    setShowMaterialsConsultantDepartment(false);
    setShowMaterialsDepartmentSec(false);
    setShowResultSub(false);
    setShowSellLeadLoop(false);
    setShowSellMSAPI(false);
    setShowAddresBook(false);
    setShowPackageDesc(false);
    setShowCheckListLawsuit(false);
    setShowLetters(false);
    setShowLettersBank(false);
    setShowLettersAggr(false);
    setShowDisc(false);
    setShowBanksOld(false);
    setShowLettersLawsuit(false);
    setShowReportClients(false);
    setShowSellLeadLoopChf(false);
    setShowCheckListLawsuitSKD(false);
    setShowSupport(false);
    setShowQuestionsCHF(false);
    setShowQuestionsSKD(false);
    setShowLettersLawsuitSKD(false);
    setShowLText(false);
    setShowLTextList(false);
    setShowHearingSubject(false);
    setShowTaskLoop(false);
    setShowExpectedResults(false);
    setShowJudges(false);
    setShowJudgesK(false);
    setShowPriceList(false);
    setShowStatuses(false);
  };

  const showUsersF = () => {
    setShowUsers(true);
    setShowBanks(false);
    setShowCourts(false);
    setShowLawyers(false);
    setShowSubstitutes(false);
    setShowResults(false);
    setShowTasksTypes(false);
    setShowSellTasksTypes(false);
    setShowMailTemplates(false);
    setShowCountHolidays(false);
    setShowSellLeadSource(false);
    setShowSellMailTemplates(false);
    setShowSellSMSTemplates(false);
    setShowBankLawyers(false);
    setShowBankLawyersOffice(false);
    setShowCourtMailTemplates(false);
    setShowPelSub(false);
    setShowMaterials(false);
    setShowMaterialsConsultant(false);
    setShowMaterialsDepartment(false);
    setShowMaterialsConsultantDepartment(false);
    setShowMaterialsDepartmentSec(false);
    setShowResultSub(false);
    setShowSellLeadLoop(false);
    setShowSellMSAPI(false);
    setShowAddresBook(false);
    setShowPackageDesc(false);
    setShowCheckListLawsuit(false);
    setShowLetters(false);
    setShowLettersBank(false);
    setShowLettersAggr(false);
    setShowDisc(false);
    setShowBanksOld(false);
    setShowLettersLawsuit(false);
    setShowReportClients(false);
    setShowSellLeadLoopChf(false);
    setShowCheckListLawsuitSKD(false);
    setShowSupport(false);
    setShowQuestionsCHF(false);
    setShowQuestionsSKD(false);
    setShowLettersLawsuitSKD(false);
    setShowLText(false);
    setShowLTextList(false);
    setShowHearingSubject(false);
    setShowTaskLoop(false);
    setShowExpectedResults(false);
    setShowJudges(false);
    setShowJudgesK(false);
    setShowPriceList(false);
    setShowStatuses(false);
  };

  const showBanksF = () => {
    setShowUsers(false);
    setShowBanks(true);
    setShowCourts(false);
    setShowLawyers(false);
    setShowSubstitutes(false);
    setShowResults(false);
    setShowTasksTypes(false);
    setShowSellTasksTypes(false);
    setShowMailTemplates(false);
    setShowCountHolidays(false);
    setShowSellLeadSource(false);
    setShowSellMailTemplates(false);
    setShowSellSMSTemplates(false);
    setShowBankLawyers(false);
    setShowBankLawyersOffice(false);
    setShowCourtMailTemplates(false);
    setShowPelSub(false);
    setShowMaterials(false);
    setShowMaterialsConsultant(false);
    setShowMaterialsDepartment(false);
    setShowMaterialsConsultantDepartment(false);
    setShowMaterialsDepartmentSec(false);
    setShowResultSub(false);
    setShowSellLeadLoop(false);
    setShowSellMSAPI(false);
    setShowAddresBook(false);
    setShowPackageDesc(false);
    setShowCheckListLawsuit(false);
    setShowLetters(false);
    setShowLettersBank(false);
    setShowLettersAggr(false);
    setShowDisc(false);
    setShowBanksOld(false);
    setShowLettersLawsuit(false);
    setShowReportClients(false);
    setShowSellLeadLoopChf(false);
    setShowCheckListLawsuitSKD(false);
    setShowSupport(false);
    setShowQuestionsCHF(false);
    setShowQuestionsSKD(false);
    setShowLettersLawsuitSKD(false);
    setShowLText(false);
    setShowLTextList(false);
    setShowHearingSubject(false);
    setShowTaskLoop(false);
    setShowExpectedResults(false);
    setShowJudges(false);
    setShowJudgesK(false);
    setShowPriceList(false);
    setShowStatuses(false);
  };

  const showCourtsF = () => {
    setShowUsers(false);
    setShowBanks(false);
    setShowCourts(true);
    setShowLawyers(false);
    setShowSubstitutes(false);
    setShowResults(false);
    setShowTasksTypes(false);
    setShowSellTasksTypes(false);
    setShowMailTemplates(false);
    setShowCountHolidays(false);
    setShowSellLeadSource(false);
    setShowSellMailTemplates(false);
    setShowSellSMSTemplates(false);
    setShowBankLawyers(false);
    setShowBankLawyersOffice(false);
    setShowCourtMailTemplates(false);
    setShowPelSub(false);
    setShowMaterials(false);
    setShowMaterialsConsultant(false);
    setShowMaterialsDepartment(false);
    setShowMaterialsConsultantDepartment(false);
    setShowMaterialsDepartmentSec(false);
    setShowResultSub(false);
    setShowSellLeadLoop(false);
    setShowSellMSAPI(false);
    setShowAddresBook(false);
    setShowPackageDesc(false);
    setShowCheckListLawsuit(false);
    setShowLetters(false);
    setShowLettersBank(false);
    setShowLettersAggr(false);
    setShowDisc(false);
    setShowBanksOld(false);
    setShowLettersLawsuit(false);
    setShowReportClients(false);
    setShowSellLeadLoopChf(false);
    setShowCheckListLawsuitSKD(false);
    setShowSupport(false);
    setShowQuestionsCHF(false);
    setShowQuestionsSKD(false);
    setShowLettersLawsuitSKD(false);
    setShowLText(false);
    setShowLTextList(false);
    setShowHearingSubject(false);
    setShowTaskLoop(false);
    setShowExpectedResults(false);
    setShowJudges(false);
    setShowJudgesK(false);
    setShowPriceList(false);
    setShowStatuses(false);
  };

  const showLawyersF = () => {
    setShowUsers(false);
    setShowBanks(false);
    setShowCourts(false);
    setShowLawyers(true);
    setShowSubstitutes(false);
    setShowResults(false);
    setShowTasksTypes(false);
    setShowSellTasksTypes(false);
    setShowMailTemplates(false);
    setShowCountHolidays(false);
    setShowSellLeadSource(false);
    setShowSellMailTemplates(false);
    setShowSellSMSTemplates(false);
    setShowBankLawyers(false);
    setShowBankLawyersOffice(false);
    setShowCourtMailTemplates(false);
    setShowPelSub(false);
    setShowMaterials(false);
    setShowMaterialsConsultant(false);
    setShowMaterialsDepartment(false);
    setShowMaterialsConsultantDepartment(false);
    setShowMaterialsDepartmentSec(false);
    setShowResultSub(false);
    setShowSellLeadLoop(false);
    setShowSellMSAPI(false);
    setShowAddresBook(false);
    setShowPackageDesc(false);
    setShowCheckListLawsuit(false);
    setShowLetters(false);
    setShowLettersBank(false);
    setShowLettersAggr(false);
    setShowDisc(false);
    setShowBanksOld(false);
    setShowLettersLawsuit(false);
    setShowReportClients(false);
    setShowSellLeadLoopChf(false);
    setShowCheckListLawsuitSKD(false);
    setShowSupport(false);
    setShowQuestionsCHF(false);
    setShowQuestionsSKD(false);
    setShowLettersLawsuitSKD(false);
    setShowLText(false);
    setShowLTextList(false);
    setShowHearingSubject(false);
    setShowTaskLoop(false);
    setShowExpectedResults(false);
    setShowJudges(false);
    setShowJudgesK(false);
    setShowPriceList(false);
    setShowStatuses(false);
  };

  const showSubstitutesF = () => {
    setShowUsers(false);
    setShowBanks(false);
    setShowCourts(false);
    setShowLawyers(false);
    setShowSubstitutes(true);
    setShowResults(false);
    setShowTasksTypes(false);
    setShowSellTasksTypes(false);
    setShowMailTemplates(false);
    setShowCountHolidays(false);
    setShowSellLeadSource(false);
    setShowSellMailTemplates(false);
    setShowSellSMSTemplates(false);
    setShowBankLawyers(false);
    setShowBankLawyersOffice(false);
    setShowCourtMailTemplates(false);
    setShowPelSub(false);
    setShowMaterials(false);
    setShowMaterialsConsultant(false);
    setShowMaterialsDepartment(false);
    setShowMaterialsConsultantDepartment(false);
    setShowMaterialsDepartmentSec(false);
    setShowResultSub(false);
    setShowSellLeadLoop(false);
    setShowSellMSAPI(false);
    setShowAddresBook(false);
    setShowPackageDesc(false);
    setShowCheckListLawsuit(false);
    setShowLetters(false);
    setShowLettersBank(false);
    setShowLettersAggr(false);
    setShowDisc(false);
    setShowBanksOld(false);
    setShowLettersLawsuit(false);
    setShowReportClients(false);
    setShowSellLeadLoopChf(false);
    setShowCheckListLawsuitSKD(false);
    setShowSupport(false);
    setShowQuestionsCHF(false);
    setShowQuestionsSKD(false);
    setShowLettersLawsuitSKD(false);
    setShowLText(false);
    setShowLTextList(false);
    setShowHearingSubject(false);
    setShowTaskLoop(false);
    setShowExpectedResults(false);
    setShowJudges(false);
    setShowJudgesK(false);
    setShowPriceList(false);
    setShowStatuses(false);
  };

  const showResultsF = () => {
    setShowUsers(false);
    setShowBanks(false);
    setShowCourts(false);
    setShowLawyers(false);
    setShowSubstitutes(false);
    setShowResults(true);
    setShowTasksTypes(false);
    setShowSellTasksTypes(false);
    setShowMailTemplates(false);
    setShowCountHolidays(false);
    setShowSellLeadSource(false);
    setShowSellMailTemplates(false);
    setShowSellSMSTemplates(false);
    setShowBankLawyers(false);
    setShowBankLawyersOffice(false);
    setShowCourtMailTemplates(false);
    setShowPelSub(false);
    setShowMaterials(false);
    setShowMaterialsConsultant(false);
    setShowMaterialsDepartment(false);
    setShowMaterialsConsultantDepartment(false);
    setShowMaterialsDepartmentSec(false);
    setShowResultSub(false);
    setShowSellLeadLoop(false);
    setShowSellMSAPI(false);
    setShowAddresBook(false);
    setShowPackageDesc(false);
    setShowCheckListLawsuit(false);
    setShowLetters(false);
    setShowLettersBank(false);
    setShowLettersAggr(false);
    setShowDisc(false);
    setShowBanksOld(false);
    setShowLettersLawsuit(false);
    setShowReportClients(false);
    setShowSellLeadLoopChf(false);
    setShowCheckListLawsuitSKD(false);
    setShowSupport(false);
    setShowQuestionsCHF(false);
    setShowQuestionsSKD(false);
    setShowLettersLawsuitSKD(false);
    setShowLText(false);
    setShowLTextList(false);
    setShowHearingSubject(false);
    setShowTaskLoop(false);
    setShowExpectedResults(false);
    setShowJudges(false);
    setShowJudgesK(false);
    setShowPriceList(false);
    setShowStatuses(false);
  };

  const showTasksTypesF = () => {
    setShowUsers(false);
    setShowBanks(false);
    setShowCourts(false);
    setShowLawyers(false);
    setShowSubstitutes(false);
    setShowResults(false);
    setShowMailTemplates(false);
    setShowTasksTypes(true);
    setShowSellTasksTypes(false);
    setShowCountHolidays(false);
    setShowSellLeadSource(false);
    setShowSellMailTemplates(false);
    setShowSellSMSTemplates(false);
    setShowBankLawyers(false);
    setShowBankLawyersOffice(false);
    setShowCourtMailTemplates(false);
    setShowPelSub(false);
    setShowMaterials(false);
    setShowMaterialsConsultant(false);
    setShowMaterialsDepartment(false);
    setShowMaterialsConsultantDepartment(false);
    setShowMaterialsDepartmentSec(false);
    setShowResultSub(false);
    setShowSellLeadLoop(false);
    setShowSellMSAPI(false);
    setShowAddresBook(false);
    setShowPackageDesc(false);
    setShowCheckListLawsuit(false);
    setShowLetters(false);
    setShowLettersBank(false);
    setShowLettersAggr(false);
    setShowDisc(false);
    setShowBanksOld(false);
    setShowLettersLawsuit(false);
    setShowReportClients(false);
    setShowSellLeadLoopChf(false);
    setShowCheckListLawsuitSKD(false);
    setShowSupport(false);
    setShowQuestionsCHF(false);
    setShowQuestionsSKD(false);
    setShowLettersLawsuitSKD(false);
    setShowLText(false);
    setShowLTextList(false);
    setShowHearingSubject(false);
    setShowTaskLoop(false);
    setShowExpectedResults(false);
    setShowJudges(false);
    setShowJudgesK(false);
    setShowPriceList(false);
    setShowStatuses(false);
  };

  const showSellTasksTypesF = () => {
    setShowUsers(false);
    setShowBanks(false);
    setShowCourts(false);
    setShowLawyers(false);
    setShowSubstitutes(false);
    setShowResults(false);
    setShowMailTemplates(false);
    setShowTasksTypes(false);
    setShowSellTasksTypes(true);
    setShowCountHolidays(false);
    setShowSellLeadSource(false);
    setShowSellMailTemplates(false);
    setShowSellSMSTemplates(false);
    setShowBankLawyers(false);
    setShowBankLawyersOffice(false);
    setShowCourtMailTemplates(false);
    setShowPelSub(false);
    setShowMaterials(false);
    setShowMaterialsConsultant(false);
    setShowMaterialsDepartment(false);
    setShowMaterialsConsultantDepartment(false);
    setShowMaterialsDepartmentSec(false);
    setShowResultSub(false);
    setShowSellLeadLoop(false);
    setShowSellMSAPI(false);
    setShowAddresBook(false);
    setShowPackageDesc(false);
    setShowCheckListLawsuit(false);
    setShowLetters(false);
    setShowLettersBank(false);
    setShowLettersAggr(false);
    setShowDisc(false);
    setShowBanksOld(false);
    setShowLettersLawsuit(false);
    setShowReportClients(false);
    setShowSellLeadLoopChf(false);
    setShowCheckListLawsuitSKD(false);
    setShowSupport(false);
    setShowQuestionsCHF(false);
    setShowQuestionsSKD(false);
    setShowLettersLawsuitSKD(false);
    setShowLText(false);
    setShowLTextList(false);
    setShowHearingSubject(false);
    setShowTaskLoop(false);
    setShowExpectedResults(false);
    setShowJudges(false);
    setShowJudgesK(false);
    setShowPriceList(false);
    setShowStatuses(false);
  };

  const showMailTemplatesF = () => {
    setShowUsers(false);
    setShowBanks(false);
    setShowCourts(false);
    setShowLawyers(false);
    setShowSubstitutes(false);
    setShowResults(false);
    setShowTasksTypes(false);
    setShowMailTemplates(true);
    setShowSellTasksTypes(false);
    setShowCountHolidays(false);
    setShowSellLeadSource(false);
    setShowSellMailTemplates(false);
    setShowSellSMSTemplates(false);
    setShowBankLawyers(false);
    setShowBankLawyersOffice(false);
    setShowCourtMailTemplates(false);
    setShowPelSub(false);
    setShowMaterials(false);
    setShowMaterialsConsultant(false);
    setShowMaterialsDepartment(false);
    setShowMaterialsConsultantDepartment(false);
    setShowMaterialsDepartmentSec(false);
    setShowResultSub(false);
    setShowSellLeadLoop(false);
    setShowSellMSAPI(false);
    setShowAddresBook(false);
    setShowPackageDesc(false);
    setShowCheckListLawsuit(false);
    setShowLetters(false);
    setShowLettersBank(false);
    setShowLettersAggr(false);
    setShowDisc(false);
    setShowBanksOld(false);
    setShowLettersLawsuit(false);
    setShowReportClients(false);
    setShowSellLeadLoopChf(false);
    setShowCheckListLawsuitSKD(false);
    setShowSupport(false);
    setShowQuestionsCHF(false);
    setShowQuestionsSKD(false);
    setShowLettersLawsuitSKD(false);
    setShowLText(false);
    setShowLTextList(false);
    setShowHearingSubject(false);
    setShowTaskLoop(false);
    setShowExpectedResults(false);
    setShowJudges(false);
    setShowJudgesK(false);
    setShowPriceList(false);
    setShowStatuses(false);
  };

  const showCountHolidaysF = () => {
    setShowUsers(false);
    setShowBanks(false);
    setShowCourts(false);
    setShowLawyers(false);
    setShowSubstitutes(false);
    setShowResults(false);
    setShowTasksTypes(false);
    setShowSellTasksTypes(false);
    setShowMailTemplates(false);
    setShowCountHolidays(true);
    setShowSellLeadSource(false);
    setShowSellMailTemplates(false);
    setShowSellSMSTemplates(false);
    setShowBankLawyers(false);
    setShowBankLawyersOffice(false);
    setShowCourtMailTemplates(false);
    setShowPelSub(false);
    setShowMaterials(false);
    setShowMaterialsConsultant(false);
    setShowMaterialsDepartment(false);
    setShowMaterialsConsultantDepartment(false);
    setShowMaterialsDepartmentSec(false);
    setShowResultSub(false);
    setShowSellLeadLoop(false);
    setShowSellMSAPI(false);
    setShowAddresBook(false);
    setShowPackageDesc(false);
    setShowCheckListLawsuit(false);
    setShowLetters(false);
    setShowLettersBank(false);
    setShowLettersAggr(false);
    setShowDisc(false);
    setShowBanksOld(false);
    setShowLettersLawsuit(false);
    setShowReportClients(false);
    setShowSellLeadLoopChf(false);
    setShowCheckListLawsuitSKD(false);
    setShowSupport(false);
    setShowQuestionsCHF(false);
    setShowQuestionsSKD(false);
    setShowLettersLawsuitSKD(false);
    setShowLText(false);
    setShowLTextList(false);
    setShowHearingSubject(false);
    setShowTaskLoop(false);
    setShowExpectedResults(false);
    setShowJudges(false);
    setShowJudgesK(false);
    setShowPriceList(false);
    setShowStatuses(false);
  };

  const showBankLawyersF = () => {
    setShowUsers(false);
    setShowBanks(false);
    setShowCourts(false);
    setShowLawyers(false);
    setShowSubstitutes(false);
    setShowResults(false);
    setShowTasksTypes(false);
    setShowSellTasksTypes(false);
    setShowMailTemplates(false);
    setShowCountHolidays(false);
    setShowSellLeadSource(false);
    setShowSellMailTemplates(false);
    setShowSellSMSTemplates(false);
    setShowBankLawyers(true);
    setShowBankLawyersOffice(false);
    setShowCourtMailTemplates(false);
    setShowPelSub(false);
    setShowMaterials(false);
    setShowMaterialsConsultant(false);
    setShowMaterialsDepartment(false);
    setShowMaterialsConsultantDepartment(false);
    setShowMaterialsDepartmentSec(false);
    setShowResultSub(false);
    setShowSellLeadLoop(false);
    setShowSellMSAPI(false);
    setShowAddresBook(false);
    setShowPackageDesc(false);
    setShowCheckListLawsuit(false);
    setShowLetters(false);
    setShowLettersBank(false);
    setShowLettersAggr(false);
    setShowDisc(false);
    setShowBanksOld(false);
    setShowLettersLawsuit(false);
    setShowReportClients(false);
    setShowSellLeadLoopChf(false);
    setShowCheckListLawsuitSKD(false);
    setShowSupport(false);
    setShowQuestionsCHF(false);
    setShowQuestionsSKD(false);
    setShowLettersLawsuitSKD(false);
    setShowLText(false);
    setShowLTextList(false);
    setShowHearingSubject(false);
    setShowTaskLoop(false);
    setShowExpectedResults(false);
    setShowJudges(false);
    setShowJudgesK(false);
    setShowPriceList(false);
    setShowStatuses(false);
  };

  const showBankLawyersOfficeF = () => {
    setShowUsers(false);
    setShowBanks(false);
    setShowCourts(false);
    setShowLawyers(false);
    setShowSubstitutes(false);
    setShowResults(false);
    setShowTasksTypes(false);
    setShowSellTasksTypes(false);
    setShowMailTemplates(false);
    setShowCountHolidays(false);
    setShowSellLeadSource(false);
    setShowSellMailTemplates(false);
    setShowSellSMSTemplates(false);
    setShowBankLawyers(false);
    setShowBankLawyersOffice(true);
    setShowCourtMailTemplates(false);
    setShowPelSub(false);
    setShowMaterials(false);
    setShowMaterialsConsultant(false);
    setShowMaterialsDepartment(false);
    setShowMaterialsConsultantDepartment(false);
    setShowMaterialsDepartmentSec(false);
    setShowResultSub(false);
    setShowSellLeadLoop(false);
    setShowSellMSAPI(false);
    setShowAddresBook(false);
    setShowPackageDesc(false);
    setShowCheckListLawsuit(false);
    setShowLetters(false);
    setShowLettersBank(false);
    setShowLettersAggr(false);
    setShowDisc(false);
    setShowBanksOld(false);
    setShowLettersLawsuit(false);
    setShowReportClients(false);
    setShowSellLeadLoopChf(false);
    setShowCheckListLawsuitSKD(false);
    setShowSupport(false);
    setShowQuestionsCHF(false);
    setShowQuestionsSKD(false);
    setShowLettersLawsuitSKD(false);
    setShowLText(false);
    setShowLTextList(false);
    setShowHearingSubject(false);
    setShowTaskLoop(false);
    setShowExpectedResults(false);
    setShowJudges(false);
    setShowJudgesK(false);
    setShowPriceList(false);
    setShowStatuses(false);
  };

  const showMaterialsF = () => {
    setShowUsers(false);
    setShowBanks(false);
    setShowCourts(false);
    setShowLawyers(false);
    setShowSubstitutes(false);
    setShowResults(false);
    setShowTasksTypes(false);
    setShowSellTasksTypes(false);
    setShowMailTemplates(false);
    setShowCountHolidays(false);
    setShowSellLeadSource(false);
    setShowSellMailTemplates(false);
    setShowSellSMSTemplates(false);
    setShowBankLawyers(false);
    setShowBankLawyersOffice(false);
    setShowCourtMailTemplates(false);
    setShowPelSub(false);
    setShowMaterials(true);
    setShowMaterialsConsultant(false);
    setShowMaterialsDepartment(false);
    setShowMaterialsConsultantDepartment(false);
    setShowMaterialsDepartmentSec(false);
    setShowResultSub(false);
    setShowSellLeadLoop(false);
    setShowSellMSAPI(false);
    setShowAddresBook(false);
    setShowPackageDesc(false);
    setShowCheckListLawsuit(false);
    setShowLetters(false);
    setShowLettersBank(false);
    setShowLettersAggr(false);
    setShowDisc(false);
    setShowBanksOld(false);
    setShowLettersLawsuit(false);
    setShowReportClients(false);
    setShowSellLeadLoopChf(false);
    setShowCheckListLawsuitSKD(false);
    setShowSupport(false);
    setShowQuestionsCHF(false);
    setShowQuestionsSKD(false);
    setShowLettersLawsuitSKD(false);
    setShowLText(false);
    setShowLTextList(false);
    setShowHearingSubject(false);
    setShowTaskLoop(false);
    setShowExpectedResults(false);
    setShowJudges(false);
    setShowJudgesK(false);
    setShowPriceList(false);
    setShowStatuses(false);
  };

  const showMaterialsConsultantF = () => {
    setShowUsers(false);
    setShowBanks(false);
    setShowCourts(false);
    setShowLawyers(false);
    setShowSubstitutes(false);
    setShowResults(false);
    setShowTasksTypes(false);
    setShowSellTasksTypes(false);
    setShowMailTemplates(false);
    setShowCountHolidays(false);
    setShowSellLeadSource(false);
    setShowSellMailTemplates(false);
    setShowSellSMSTemplates(false);
    setShowBankLawyers(false);
    setShowBankLawyersOffice(false);
    setShowCourtMailTemplates(false);
    setShowPelSub(false);
    setShowMaterials(false);
    setShowMaterialsConsultant(true);
    setShowMaterialsDepartment(false);
    setShowMaterialsConsultantDepartment(false);
    setShowMaterialsDepartmentSec(false);
    setShowResultSub(false);
    setShowSellLeadLoop(false);
    setShowSellMSAPI(false);
    setShowAddresBook(false);
    setShowPackageDesc(false);
    setShowCheckListLawsuit(false);
    setShowLetters(false);
    setShowLettersBank(false);
    setShowLettersAggr(false);
    setShowDisc(false);
    setShowBanksOld(false);
    setShowLettersLawsuit(false);
    setShowReportClients(false);
    setShowSellLeadLoopChf(false);
    setShowCheckListLawsuitSKD(false);
    setShowSupport(false);
    setShowQuestionsCHF(false);
    setShowQuestionsSKD(false);
    setShowLettersLawsuitSKD(false);
    setShowLText(false);
    setShowLTextList(false);
    setShowHearingSubject(false);
    setShowTaskLoop(false);
    setShowExpectedResults(false);
    setShowJudges(false);
    setShowJudgesK(false);
    setShowPriceList(false);
    setShowStatuses(false);
  };

  const showMaterialsDepartmentF = () => {
    setShowUsers(false);
    setShowBanks(false);
    setShowCourts(false);
    setShowLawyers(false);
    setShowSubstitutes(false);
    setShowResults(false);
    setShowTasksTypes(false);
    setShowSellTasksTypes(false);
    setShowMailTemplates(false);
    setShowCountHolidays(false);
    setShowSellLeadSource(false);
    setShowSellMailTemplates(false);
    setShowSellSMSTemplates(false);
    setShowBankLawyers(false);
    setShowBankLawyersOffice(false);
    setShowCourtMailTemplates(false);
    setShowPelSub(false);
    setShowMaterials(false);
    setShowMaterialsConsultant(false);
    setShowMaterialsDepartment(true);
    setShowMaterialsConsultantDepartment(false);
    setShowMaterialsDepartmentSec(false);
    setShowResultSub(false);
    setShowSellLeadLoop(false);
    setShowSellMSAPI(false);
    setShowAddresBook(false);
    setShowPackageDesc(false);
    setShowCheckListLawsuit(false);
    setShowLetters(false);
    setShowLettersBank(false);
    setShowLettersAggr(false);
    setShowDisc(false);
    setShowBanksOld(false);
    setShowLettersLawsuit(false);
    setShowReportClients(false);
    setShowSellLeadLoopChf(false);
    setShowCheckListLawsuitSKD(false);
    setShowSupport(false);
    setShowQuestionsCHF(false);
    setShowQuestionsSKD(false);
    setShowLettersLawsuitSKD(false);
    setShowLText(false);
    setShowLTextList(false);
    setShowHearingSubject(false);
    setShowTaskLoop(false);
    setShowJudges(false);
    setShowExpectedResults(false);
    setShowJudgesK(false);
    setShowPriceList(false);
    setShowStatuses(false);
  };

  const showMaterialsDepartmentSecF = () => {
    setShowUsers(false);
    setShowBanks(false);
    setShowCourts(false);
    setShowLawyers(false);
    setShowSubstitutes(false);
    setShowResults(false);
    setShowTasksTypes(false);
    setShowSellTasksTypes(false);
    setShowMailTemplates(false);
    setShowCountHolidays(false);
    setShowSellLeadSource(false);
    setShowSellMailTemplates(false);
    setShowSellSMSTemplates(false);
    setShowBankLawyers(false);
    setShowBankLawyersOffice(false);
    setShowCourtMailTemplates(false);
    setShowPelSub(false);
    setShowMaterials(false);
    setShowMaterialsConsultant(false);
    setShowMaterialsDepartment(false);
    setShowMaterialsConsultantDepartment(false);
    setShowMaterialsDepartmentSec(true);
    setShowResultSub(false);
    setShowSellLeadLoop(false);
    setShowSellMSAPI(false);
    setShowAddresBook(false);
    setShowPackageDesc(false);
    setShowCheckListLawsuit(false);
    setShowLetters(false);
    setShowLettersBank(false);
    setShowLettersAggr(false);
    setShowDisc(false);
    setShowBanksOld(false);
    setShowLettersLawsuit(false);
    setShowReportClients(false);
    setShowSellLeadLoopChf(false);
    setShowCheckListLawsuitSKD(false);
    setShowSupport(false);
    setShowQuestionsCHF(false);
    setShowQuestionsSKD(false);
    setShowLettersLawsuitSKD(false);
    setShowLText(false);
    setShowLTextList(false);
    setShowHearingSubject(false);
    setShowTaskLoop(false);
    setShowExpectedResults(false);
    setShowJudges(false);
    setShowJudgesK(false);
    setShowPriceList(false);
    setShowStatuses(false);
  };

  const showResultSubF = () => {
    setShowUsers(false);
    setShowBanks(false);
    setShowCourts(false);
    setShowLawyers(false);
    setShowSubstitutes(false);
    setShowResults(false);
    setShowTasksTypes(false);
    setShowSellTasksTypes(false);
    setShowMailTemplates(false);
    setShowCountHolidays(false);
    setShowSellLeadSource(false);
    setShowSellMailTemplates(false);
    setShowSellSMSTemplates(false);
    setShowBankLawyers(false);
    setShowBankLawyersOffice(false);
    setShowCourtMailTemplates(false);
    setShowPelSub(false);
    setShowMaterials(false);
    setShowMaterialsConsultant(false);
    setShowMaterialsDepartment(false);
    setShowMaterialsConsultantDepartment(false);
    setShowMaterialsDepartmentSec(false);
    setShowResultSub(true);
    setShowSellLeadLoop(false);
    setShowSellMSAPI(false);
    setShowAddresBook(false);
    setShowPackageDesc(false);
    setShowCheckListLawsuit(false);
    setShowLetters(false);
    setShowLettersBank(false);
    setShowLettersAggr(false);
    setShowDisc(false);
    setShowBanksOld(false);
    setShowLettersLawsuit(false);
    setShowReportClients(false);
    setShowSellLeadLoopChf(false);
    setShowCheckListLawsuitSKD(false);
    setShowSupport(false);
    setShowQuestionsCHF(false);
    setShowQuestionsSKD(false);
    setShowLettersLawsuitSKD(false);
    setShowLText(false);
    setShowLTextList(false);
    setShowHearingSubject(false);
    setShowTaskLoop(false);
    setShowExpectedResults(false);
    setShowJudges(false);
    setShowJudgesK(false);
    setShowPriceList(false);
    setShowStatuses(false);
  };

  const showMaterialsConsultantDepartmentF = () => {
    setShowUsers(false);
    setShowBanks(false);
    setShowCourts(false);
    setShowLawyers(false);
    setShowSubstitutes(false);
    setShowResults(false);
    setShowTasksTypes(false);
    setShowSellTasksTypes(false);
    setShowMailTemplates(false);
    setShowCountHolidays(false);
    setShowSellLeadSource(false);
    setShowSellMailTemplates(false);
    setShowSellSMSTemplates(false);
    setShowBankLawyers(false);
    setShowBankLawyersOffice(false);
    setShowCourtMailTemplates(false);
    setShowPelSub(false);
    setShowMaterials(false);
    setShowMaterialsConsultant(false);
    setShowMaterialsDepartment(false);
    setShowMaterialsConsultantDepartment(true);
    setShowMaterialsDepartmentSec(false);
    setShowSellLeadLoop(false);
    setShowSellMSAPI(false);
    setShowAddresBook(false);
    setShowPackageDesc(false);
    setShowLetters(false);
    setShowCheckListLawsuit(false);
    setShowLettersBank(false);
    setShowLettersAggr(false);
    setShowDisc(false);
    setShowBanksOld(false);
    setShowLettersLawsuit(false);
    setShowReportClients(false);
    setShowSellLeadLoopChf(false);
    setShowCheckListLawsuitSKD(false);
    setShowSupport(false);
    setShowQuestionsCHF(false);
    setShowQuestionsSKD(false);
    setShowLettersLawsuitSKD(false);
    setShowLText(false);
    setShowLTextList(false);
    setShowHearingSubject(false);
    setShowTaskLoop(false);
    setShowExpectedResults(false);
    setShowJudges(false);
    setShowJudgesK(false);
    setShowPriceList(false);
    setShowStatuses(false);
  };

  const showSellLeadLoopF = () => {
    setShowUsers(false);
    setShowBanks(false);
    setShowCourts(false);
    setShowLawyers(false);
    setShowSubstitutes(false);
    setShowResults(false);
    setShowTasksTypes(false);
    setShowSellTasksTypes(false);
    setShowMailTemplates(false);
    setShowCountHolidays(false);
    setShowSellLeadSource(false);
    setShowSellMailTemplates(false);
    setShowSellSMSTemplates(false);
    setShowBankLawyers(false);
    setShowBankLawyersOffice(false);
    setShowCourtMailTemplates(false);
    setShowPelSub(false);
    setShowMaterials(false);
    setShowMaterialsConsultant(false);
    setShowMaterialsDepartment(false);
    setShowMaterialsConsultantDepartment(false);
    setShowMaterialsDepartmentSec(false);
    setShowSellLeadLoop(true);
    setShowAddresBook(false);
    setShowSellMSAPI(false);
    setShowPackageDesc(false);
    setShowCheckListLawsuit(false);
    setShowLetters(false);
    setShowLettersBank(false);
    setShowLettersAggr(false);
    setShowDisc(false);
    setShowBanksOld(false);
    setShowLettersLawsuit(false);
    setShowReportClients(false);
    setShowSellLeadLoopChf(false);
    setShowCheckListLawsuitSKD(false);
    setShowSupport(false);
    setShowQuestionsCHF(false);
    setShowQuestionsSKD(false);
    setShowLettersLawsuitSKD(false);
    setShowLText(false);
    setShowLTextList(false);
    setShowHearingSubject(false);
    setShowTaskLoop(false);
    setShowExpectedResults(false);
    setShowJudges(false);
    setShowJudgesK(false);
    setShowPriceList(false);
    setShowStatuses(false);
  };

  const showSellMSAPIF = () => {
    setShowUsers(false);
    setShowBanks(false);
    setShowCourts(false);
    setShowLawyers(false);
    setShowSubstitutes(false);
    setShowResults(false);
    setShowTasksTypes(false);
    setShowSellTasksTypes(false);
    setShowMailTemplates(false);
    setShowCountHolidays(false);
    setShowSellLeadSource(false);
    setShowSellMailTemplates(false);
    setShowSellSMSTemplates(false);
    setShowBankLawyers(false);
    setShowBankLawyersOffice(false);
    setShowCourtMailTemplates(false);
    setShowPelSub(false);
    setShowMaterials(false);
    setShowMaterialsConsultant(false);
    setShowMaterialsDepartment(false);
    setShowMaterialsConsultantDepartment(false);
    setShowMaterialsDepartmentSec(false);
    setShowSellLeadLoop(false);
    setShowSellMSAPI(true);
    setShowAddresBook(false);
    setShowPackageDesc(false);
    setShowCheckListLawsuit(false);
    setShowLetters(false);
    setShowLettersBank(false);
    setShowLettersAggr(false);
    setShowDisc(false);
    setShowBanksOld(false);
    setShowLettersLawsuit(false);
    setShowReportClients(false);
    setShowSellLeadLoopChf(false);
    setShowCheckListLawsuitSKD(false);
    setShowSupport(false);
    setShowQuestionsCHF(false);
    setShowQuestionsSKD(false);
    setShowLettersLawsuitSKD(false);
    setShowLText(false);
    setShowLTextList(false);
    setShowHearingSubject(false);
    setShowTaskLoop(false);
    setShowExpectedResults(false);
    setShowJudges(false);
    setShowJudgesK(false);
    setShowPriceList(false);
    setShowStatuses(false);
  };

  const showAddressBookF = () => {
    setShowUsers(false);
    setShowBanks(false);
    setShowCourts(false);
    setShowLawyers(false);
    setShowSubstitutes(false);
    setShowResults(false);
    setShowTasksTypes(false);
    setShowSellTasksTypes(false);
    setShowMailTemplates(false);
    setShowCountHolidays(false);
    setShowSellLeadSource(false);
    setShowSellMailTemplates(false);
    setShowSellSMSTemplates(false);
    setShowBankLawyers(false);
    setShowBankLawyersOffice(false);
    setShowCourtMailTemplates(false);
    setShowPelSub(false);
    setShowMaterials(false);
    setShowMaterialsConsultant(false);
    setShowMaterialsDepartment(false);
    setShowMaterialsConsultantDepartment(false);
    setShowMaterialsDepartmentSec(false);
    setShowSellLeadLoop(false);
    setShowSellMSAPI(false);
    setShowAddresBook(true);
    setShowPackageDesc(false);
    setShowCheckListLawsuit(false);
    setShowLetters(false);
    setShowLettersBank(false);
    setShowLettersAggr(false);
    setShowDisc(false);
    setShowBanksOld(false);
    setShowLettersLawsuit(false);
    setShowReportClients(false);
    setShowSellLeadLoopChf(false);
    setShowCheckListLawsuitSKD(false);
    setShowSupport(false);
    setShowQuestionsCHF(false);
    setShowQuestionsSKD(false);
    setShowLettersLawsuitSKD(false);
    setShowLText(false);
    setShowLTextList(false);
    setShowHearingSubject(false);
    setShowTaskLoop(false);
    setShowExpectedResults(false);
    setShowJudges(false);
    setShowJudgesK(false);
    setShowPriceList(false);
    setShowStatuses(false);
  };

  const showPackageDescF = () => {
    setShowUsers(false);
    setShowBanks(false);
    setShowCourts(false);
    setShowLawyers(false);
    setShowSubstitutes(false);
    setShowResults(false);
    setShowTasksTypes(false);
    setShowSellTasksTypes(false);
    setShowMailTemplates(false);
    setShowCountHolidays(false);
    setShowSellLeadSource(false);
    setShowSellMailTemplates(false);
    setShowSellSMSTemplates(false);
    setShowBankLawyers(false);
    setShowBankLawyersOffice(false);
    setShowCourtMailTemplates(false);
    setShowPelSub(false);
    setShowMaterials(false);
    setShowMaterialsConsultant(false);
    setShowMaterialsDepartment(false);
    setShowMaterialsConsultantDepartment(false);
    setShowMaterialsDepartmentSec(false);
    setShowSellLeadLoop(false);
    setShowSellMSAPI(false);
    setShowAddresBook(false);
    setShowPackageDesc(true);
    setShowCheckListLawsuit(false);
    setShowLetters(false);
    setShowLettersBank(false);
    setShowLettersAggr(false);
    setShowDisc(false);
    setShowBanksOld(false);
    setShowLettersLawsuit(false);
    setShowReportClients(false);
    setShowSellLeadLoopChf(false);
    setShowCheckListLawsuitSKD(false);
    setShowSupport(false);
    setShowQuestionsCHF(false);
    setShowQuestionsSKD(false);
    setShowLettersLawsuitSKD(false);
    setShowLText(false);
    setShowLTextList(false);
    setShowHearingSubject(false);
    setShowTaskLoop(false);
    setShowExpectedResults(false);
    setShowJudges(false);
    setShowJudgesK(false);
    setShowPriceList(false);
    setShowStatuses(false);
  };

  const showPChecklistLawsuitF = () => {
    setShowUsers(false);
    setShowBanks(false);
    setShowCourts(false);
    setShowLawyers(false);
    setShowSubstitutes(false);
    setShowResults(false);
    setShowTasksTypes(false);
    setShowSellTasksTypes(false);
    setShowMailTemplates(false);
    setShowCountHolidays(false);
    setShowSellLeadSource(false);
    setShowSellMailTemplates(false);
    setShowSellSMSTemplates(false);
    setShowBankLawyers(false);
    setShowBankLawyersOffice(false);
    setShowCourtMailTemplates(false);
    setShowPelSub(false);
    setShowMaterials(false);
    setShowMaterialsConsultant(false);
    setShowMaterialsDepartment(false);
    setShowMaterialsConsultantDepartment(false);
    setShowMaterialsDepartmentSec(false);
    setShowSellLeadLoop(false);
    setShowSellMSAPI(false);
    setShowAddresBook(false);
    setShowPackageDesc(false);
    setShowCheckListLawsuit(true);
    setShowLetters(false);
    setShowLettersBank(false);
    setShowLettersAggr(false);
    setShowDisc(false);
    setShowBanksOld(false);
    setShowLettersLawsuit(false);
    setShowReportClients(false);
    setShowSellLeadLoopChf(false);
    setShowCheckListLawsuitSKD(false);
    setShowSupport(false);
    setShowQuestionsCHF(false);
    setShowQuestionsSKD(false);
    setShowLettersLawsuitSKD(false);
    setShowLText(false);
    setShowLTextList(false);
    setShowHearingSubject(false);
    setShowTaskLoop(false);
    setShowExpectedResults(false);
    setShowJudges(false);
    setShowJudgesK(false);
    setShowPriceList(false);
    setShowStatuses(false);
  };

  const showLettersF = () => {
    setShowUsers(false);
    setShowBanks(false);
    setShowCourts(false);
    setShowLawyers(false);
    setShowSubstitutes(false);
    setShowResults(false);
    setShowTasksTypes(false);
    setShowSellTasksTypes(false);
    setShowMailTemplates(false);
    setShowCountHolidays(false);
    setShowSellLeadSource(false);
    setShowSellMailTemplates(false);
    setShowSellSMSTemplates(false);
    setShowBankLawyers(false);
    setShowBankLawyersOffice(false);
    setShowCourtMailTemplates(false);
    setShowPelSub(false);
    setShowMaterials(false);
    setShowMaterialsConsultant(false);
    setShowMaterialsDepartment(false);
    setShowMaterialsConsultantDepartment(false);
    setShowMaterialsDepartmentSec(false);
    setShowSellLeadLoop(false);
    setShowSellMSAPI(false);
    setShowAddresBook(false);
    setShowPackageDesc(false);
    setShowCheckListLawsuit(false);
    setShowLetters(true);
    setShowLettersBank(false);
    setShowLettersAggr(false);
    setShowDisc(false);
    setShowBanksOld(false);
    setShowLettersLawsuit(false);
    setShowReportClients(false);
    setShowSellLeadLoopChf(false);
    setShowCheckListLawsuitSKD(false);
    setShowSupport(false);
    setShowQuestionsCHF(false);
    setShowQuestionsSKD(false);
    setShowLettersLawsuitSKD(false);
    setShowLText(false);
    setShowLTextList(false);
    setShowHearingSubject(false);
    setShowTaskLoop(false);
    setShowExpectedResults(false);
    setShowJudges(false);
    setShowJudgesK(false);
    setShowPriceList(false);
    setShowStatuses(false);
  };

  const showLettersBankF = () => {
    setShowUsers(false);
    setShowBanks(false);
    setShowCourts(false);
    setShowLawyers(false);
    setShowSubstitutes(false);
    setShowResults(false);
    setShowTasksTypes(false);
    setShowSellTasksTypes(false);
    setShowMailTemplates(false);
    setShowCountHolidays(false);
    setShowSellLeadSource(false);
    setShowSellMailTemplates(false);
    setShowSellSMSTemplates(false);
    setShowBankLawyers(false);
    setShowBankLawyersOffice(false);
    setShowCourtMailTemplates(false);
    setShowPelSub(false);
    setShowMaterials(false);
    setShowMaterialsConsultant(false);
    setShowMaterialsDepartment(false);
    setShowMaterialsConsultantDepartment(false);
    setShowMaterialsDepartmentSec(false);
    setShowSellLeadLoop(false);
    setShowSellMSAPI(false);
    setShowAddresBook(false);
    setShowPackageDesc(false);
    setShowCheckListLawsuit(false);
    setShowLetters(false);
    setShowLettersBank(true);
    setShowLettersAggr(false);
    setShowDisc(false);
    setShowBanksOld(false);
    setShowLettersLawsuit(false);
    setShowReportClients(false);
    setShowSellLeadLoopChf(false);
    setShowCheckListLawsuitSKD(false);
    setShowSupport(false);
    setShowQuestionsCHF(false);
    setShowQuestionsSKD(false);
    setShowLettersLawsuitSKD(false);
    setShowLText(false);
    setShowLTextList(false);
    setShowHearingSubject(false);
    setShowTaskLoop(false);
    setShowExpectedResults(false);
    setShowJudges(false);
    setShowJudgesK(false);
    setShowPriceList(false);
    setShowStatuses(false);
  };

  const showLettersAggrF = () => {
    setShowUsers(false);
    setShowBanks(false);
    setShowCourts(false);
    setShowLawyers(false);
    setShowSubstitutes(false);
    setShowResults(false);
    setShowTasksTypes(false);
    setShowSellTasksTypes(false);
    setShowMailTemplates(false);
    setShowCountHolidays(false);
    setShowSellLeadSource(false);
    setShowSellMailTemplates(false);
    setShowSellSMSTemplates(false);
    setShowBankLawyers(false);
    setShowBankLawyersOffice(false);
    setShowCourtMailTemplates(false);
    setShowPelSub(false);
    setShowMaterials(false);
    setShowMaterialsConsultant(false);
    setShowMaterialsDepartment(false);
    setShowMaterialsConsultantDepartment(false);
    setShowMaterialsDepartmentSec(false);
    setShowSellLeadLoop(false);
    setShowSellMSAPI(false);
    setShowAddresBook(false);
    setShowPackageDesc(false);
    setShowCheckListLawsuit(false);
    setShowLetters(false);
    setShowLettersBank(false);
    setShowLettersAggr(true);
    setShowDisc(false);
    setShowBanksOld(false);
    setShowLettersLawsuit(false);
    setShowReportClients(false);
    setShowSellLeadLoopChf(false);
    setShowCheckListLawsuitSKD(false);
    setShowSupport(false);
    setShowQuestionsCHF(false);
    setShowQuestionsSKD(false);
    setShowLettersLawsuitSKD(false);
    setShowLText(false);
    setShowLTextList(false);
    setShowHearingSubject(false);
    setShowTaskLoop(false);
    setShowExpectedResults(false);
    setShowJudges(false);
    setShowJudgesK(false);
    setShowPriceList(false);
    setShowStatuses(false);
  };

  const showLettersLawsuitF = () => {
    setShowUsers(false);
    setShowBanks(false);
    setShowCourts(false);
    setShowLawyers(false);
    setShowSubstitutes(false);
    setShowResults(false);
    setShowTasksTypes(false);
    setShowSellTasksTypes(false);
    setShowMailTemplates(false);
    setShowCountHolidays(false);
    setShowSellLeadSource(false);
    setShowSellMailTemplates(false);
    setShowSellSMSTemplates(false);
    setShowBankLawyers(false);
    setShowBankLawyersOffice(false);
    setShowCourtMailTemplates(false);
    setShowPelSub(false);
    setShowMaterials(false);
    setShowMaterialsConsultant(false);
    setShowMaterialsDepartment(false);
    setShowMaterialsConsultantDepartment(false);
    setShowMaterialsDepartmentSec(false);
    setShowSellLeadLoop(false);
    setShowSellMSAPI(false);
    setShowAddresBook(false);
    setShowPackageDesc(false);
    setShowCheckListLawsuit(false);
    setShowLetters(false);
    setShowLettersBank(false);
    setShowLettersAggr(false);
    setShowDisc(false);
    setShowBanksOld(false);
    setShowLettersLawsuit(true);
    setShowReportClients(false);
    setShowSellLeadLoopChf(false);
    setShowCheckListLawsuitSKD(false);
    setShowSupport(false);
    setShowQuestionsCHF(false);
    setShowQuestionsSKD(false);
    setShowLettersLawsuitSKD(false);
    setShowLText(false);
    setShowLTextList(false);
    setShowHearingSubject(false);
    setShowTaskLoop(false);
    setShowExpectedResults(false);
    setShowJudges(false);
    setShowJudgesK(false);
    setShowPriceList(false);
    setShowStatuses(false);
  };

  const showLettersLawsuitSKDF = () => {
    setShowUsers(false);
    setShowBanks(false);
    setShowCourts(false);
    setShowLawyers(false);
    setShowSubstitutes(false);
    setShowResults(false);
    setShowTasksTypes(false);
    setShowSellTasksTypes(false);
    setShowMailTemplates(false);
    setShowCountHolidays(false);
    setShowSellLeadSource(false);
    setShowSellMailTemplates(false);
    setShowSellSMSTemplates(false);
    setShowBankLawyers(false);
    setShowBankLawyersOffice(false);
    setShowCourtMailTemplates(false);
    setShowPelSub(false);
    setShowMaterials(false);
    setShowMaterialsConsultant(false);
    setShowMaterialsDepartment(false);
    setShowMaterialsConsultantDepartment(false);
    setShowMaterialsDepartmentSec(false);
    setShowSellLeadLoop(false);
    setShowSellMSAPI(false);
    setShowAddresBook(false);
    setShowPackageDesc(false);
    setShowCheckListLawsuit(false);
    setShowLetters(false);
    setShowLettersBank(false);
    setShowLettersAggr(false);
    setShowDisc(false);
    setShowBanksOld(false);
    setShowLettersLawsuit(false);
    setShowReportClients(false);
    setShowSellLeadLoopChf(false);
    setShowCheckListLawsuitSKD(false);
    setShowSupport(false);
    setShowQuestionsCHF(false);
    setShowQuestionsSKD(false);
    setShowLettersLawsuitSKD(true);
    setShowLText(false);
    setShowLTextList(false);
    setShowHearingSubject(false);
    setShowTaskLoop(false);
    setShowExpectedResults(false);
    setShowJudges(false);
    setShowJudgesK(false);
    setShowPriceList(false);
    setShowStatuses(false);
  };

  const showDiscF = () => {
    setShowUsers(false);
    setShowBanks(false);
    setShowCourts(false);
    setShowLawyers(false);
    setShowSubstitutes(false);
    setShowResults(false);
    setShowTasksTypes(false);
    setShowSellTasksTypes(false);
    setShowMailTemplates(false);
    setShowCountHolidays(false);
    setShowSellLeadSource(false);
    setShowSellMailTemplates(false);
    setShowSellSMSTemplates(false);
    setShowBankLawyers(false);
    setShowBankLawyersOffice(false);
    setShowCourtMailTemplates(false);
    setShowPelSub(false);
    setShowMaterials(false);
    setShowMaterialsConsultant(false);
    setShowMaterialsDepartment(false);
    setShowMaterialsConsultantDepartment(false);
    setShowMaterialsDepartmentSec(false);
    setShowSellLeadLoop(false);
    setShowSellMSAPI(false);
    setShowAddresBook(false);
    setShowPackageDesc(false);
    setShowCheckListLawsuit(false);
    setShowLetters(false);
    setShowLettersBank(false);
    setShowLettersAggr(false);
    setShowDisc(true);
    setShowBanksOld(false);
    setShowLettersLawsuit(false);
    setShowReportClients(false);
    setShowSellLeadLoopChf(false);
    setShowCheckListLawsuitSKD(false);
    setShowSupport(false);
    setShowQuestionsCHF(false);
    setShowQuestionsSKD(false);
    setShowLettersLawsuitSKD(false);
    setShowLText(false);
    setShowLTextList(false);
    setShowHearingSubject(false);
    setShowTaskLoop(false);
    setShowExpectedResults(false);
    setShowJudges(false);
    setShowJudgesK(false);
    setShowPriceList(false);
    setShowStatuses(false);
  };

  const showBanksOldF = () => {
    setShowUsers(false);
    setShowBanks(false);
    setShowCourts(false);
    setShowLawyers(false);
    setShowSubstitutes(false);
    setShowResults(false);
    setShowTasksTypes(false);
    setShowSellTasksTypes(false);
    setShowMailTemplates(false);
    setShowCountHolidays(false);
    setShowSellLeadSource(false);
    setShowSellMailTemplates(false);
    setShowSellSMSTemplates(false);
    setShowBankLawyers(false);
    setShowBankLawyersOffice(false);
    setShowCourtMailTemplates(false);
    setShowPelSub(false);
    setShowMaterials(false);
    setShowMaterialsConsultant(false);
    setShowMaterialsDepartment(false);
    setShowMaterialsConsultantDepartment(false);
    setShowMaterialsDepartmentSec(false);
    setShowSellLeadLoop(false);
    setShowSellMSAPI(false);
    setShowAddresBook(false);
    setShowPackageDesc(false);
    setShowCheckListLawsuit(false);
    setShowLetters(false);
    setShowLettersBank(false);
    setShowLettersAggr(false);
    setShowDisc(false);
    setShowBanksOld(true);
    setShowLettersLawsuit(false);
    setShowReportClients(false);
    setShowSellLeadLoopChf(false);
    setShowCheckListLawsuitSKD(false);
    setShowSupport(false);
    setShowQuestionsCHF(false);
    setShowQuestionsSKD(false);
    setShowLettersLawsuitSKD(false);
    setShowLText(false);
    setShowLTextList(false);
    setShowHearingSubject(false);
    setShowTaskLoop(false);
    setShowExpectedResults(false);
    setShowJudges(false);
    setShowJudgesK(false);
    setShowPriceList(false);
    setShowStatuses(false);
  };

  const showReportClientsF = () => {
    setShowUsers(false);
    setShowBanks(false);
    setShowCourts(false);
    setShowLawyers(false);
    setShowSubstitutes(false);
    setShowResults(false);
    setShowTasksTypes(false);
    setShowSellTasksTypes(false);
    setShowMailTemplates(false);
    setShowCountHolidays(false);
    setShowSellLeadSource(false);
    setShowSellMailTemplates(false);
    setShowSellSMSTemplates(false);
    setShowBankLawyers(false);
    setShowBankLawyersOffice(false);
    setShowCourtMailTemplates(false);
    setShowPelSub(false);
    setShowMaterials(false);
    setShowMaterialsConsultant(false);
    setShowMaterialsDepartment(false);
    setShowMaterialsConsultantDepartment(false);
    setShowMaterialsDepartmentSec(false);
    setShowSellLeadLoop(false);
    setShowSellMSAPI(false);
    setShowAddresBook(false);
    setShowPackageDesc(false);
    setShowCheckListLawsuit(false);
    setShowLetters(false);
    setShowLettersBank(false);
    setShowLettersAggr(false);
    setShowDisc(false);
    setShowBanksOld(false);
    setShowLettersLawsuit(false);
    setShowReportClients(true);
    setShowSellLeadLoopChf(false);
    setShowCheckListLawsuitSKD(false);
    setShowSupport(false);
    setShowQuestionsCHF(false);
    setShowQuestionsSKD(false);
    setShowLettersLawsuitSKD(false);
    setShowLText(false);
    setShowLTextList(false);
    setShowHearingSubject(false);
    setShowTaskLoop(false);
    setShowExpectedResults(false);
    setShowJudges(false);
    setShowJudgesK(false);
    setShowPriceList(false);
    setShowStatuses(false);
  };

  const showLeadLoopChfF = () => {
    setShowUsers(false);
    setShowBanks(false);
    setShowCourts(false);
    setShowLawyers(false);
    setShowSubstitutes(false);
    setShowResults(false);
    setShowTasksTypes(false);
    setShowSellTasksTypes(false);
    setShowMailTemplates(false);
    setShowCountHolidays(false);
    setShowSellLeadSource(false);
    setShowSellMailTemplates(false);
    setShowSellSMSTemplates(false);
    setShowBankLawyers(false);
    setShowBankLawyersOffice(false);
    setShowCourtMailTemplates(false);
    setShowPelSub(false);
    setShowMaterials(false);
    setShowMaterialsConsultant(false);
    setShowMaterialsDepartment(false);
    setShowMaterialsConsultantDepartment(false);
    setShowMaterialsDepartmentSec(false);
    setShowSellLeadLoop(false);
    setShowSellMSAPI(false);
    setShowAddresBook(false);
    setShowPackageDesc(false);
    setShowCheckListLawsuit(false);
    setShowLetters(false);
    setShowLettersBank(false);
    setShowLettersAggr(false);
    setShowDisc(false);
    setShowBanksOld(false);
    setShowLettersLawsuit(false);
    setShowReportClients(false);
    setShowSellLeadLoopChf(true);
    setShowCheckListLawsuitSKD(false);
    setShowSupport(false);
    setShowQuestionsCHF(false);
    setShowQuestionsSKD(false);
    setShowLettersLawsuitSKD(false);
    setShowLText(false);
    setShowLTextList(false);
    setShowHearingSubject(false);
    setShowTaskLoop(false);
    setShowExpectedResults(false);
    setShowJudges(false);
    setShowJudgesK(false);
    setShowPriceList(false);
    setShowStatuses(false);
  };

  const showCheckListLawsuitSKDF = () => {
    setShowUsers(false);
    setShowBanks(false);
    setShowCourts(false);
    setShowLawyers(false);
    setShowSubstitutes(false);
    setShowResults(false);
    setShowTasksTypes(false);
    setShowSellTasksTypes(false);
    setShowMailTemplates(false);
    setShowCountHolidays(false);
    setShowSellLeadSource(false);
    setShowSellMailTemplates(false);
    setShowSellSMSTemplates(false);
    setShowBankLawyers(false);
    setShowBankLawyersOffice(false);
    setShowCourtMailTemplates(false);
    setShowPelSub(false);
    setShowMaterials(false);
    setShowMaterialsConsultant(false);
    setShowMaterialsDepartment(false);
    setShowMaterialsConsultantDepartment(false);
    setShowMaterialsDepartmentSec(false);
    setShowSellLeadLoop(false);
    setShowSellMSAPI(false);
    setShowAddresBook(false);
    setShowPackageDesc(false);
    setShowCheckListLawsuit(false);
    setShowLetters(false);
    setShowLettersBank(false);
    setShowLettersAggr(false);
    setShowDisc(false);
    setShowBanksOld(false);
    setShowLettersLawsuit(false);
    setShowReportClients(false);
    setShowSellLeadLoopChf(false);
    setShowCheckListLawsuitSKD(true);
    setShowSupport(false);
    setShowQuestionsCHF(false);
    setShowQuestionsSKD(false);
    setShowLettersLawsuitSKD(false);
    setShowLText(false);
    setShowLTextList(false);
    setShowHearingSubject(false);
    setShowTaskLoop(false);
    setShowExpectedResults(false);
    setShowJudges(false);
    setShowJudgesK(false);
    setShowPriceList(false);
    setShowStatuses(false);
  };

  const showSupportF = () => {
    setShowUsers(false);
    setShowBanks(false);
    setShowCourts(false);
    setShowLawyers(false);
    setShowSubstitutes(false);
    setShowResults(false);
    setShowTasksTypes(false);
    setShowSellTasksTypes(false);
    setShowMailTemplates(false);
    setShowCountHolidays(false);
    setShowSellLeadSource(false);
    setShowSellMailTemplates(false);
    setShowSellSMSTemplates(false);
    setShowBankLawyers(false);
    setShowBankLawyersOffice(false);
    setShowCourtMailTemplates(false);
    setShowPelSub(false);
    setShowMaterials(false);
    setShowMaterialsConsultant(false);
    setShowMaterialsDepartment(false);
    setShowMaterialsConsultantDepartment(false);
    setShowMaterialsDepartmentSec(false);
    setShowSellLeadLoop(false);
    setShowSellMSAPI(false);
    setShowAddresBook(false);
    setShowPackageDesc(false);
    setShowCheckListLawsuit(false);
    setShowLetters(false);
    setShowLettersBank(false);
    setShowLettersAggr(false);
    setShowDisc(false);
    setShowBanksOld(false);
    setShowLettersLawsuit(false);
    setShowReportClients(false);
    setShowSellLeadLoopChf(false);
    setShowCheckListLawsuitSKD(false);
    setShowSupport(true);
    setShowQuestionsCHF(false);
    setShowQuestionsSKD(false);
    setShowLettersLawsuitSKD(false);
    setShowLText(false);
    setShowLTextList(false);
    setShowHearingSubject(false);
    setShowTaskLoop(false);
    setShowExpectedResults(false);
    setShowJudges(false);
    setShowJudgesK(false);
    setShowPriceList(false);
    setShowStatuses(false);
  };

  const showQUestiosnCHFF = () => {
    setShowUsers(false);
    setShowBanks(false);
    setShowCourts(false);
    setShowLawyers(false);
    setShowSubstitutes(false);
    setShowResults(false);
    setShowTasksTypes(false);
    setShowSellTasksTypes(false);
    setShowMailTemplates(false);
    setShowCountHolidays(false);
    setShowSellLeadSource(false);
    setShowSellMailTemplates(false);
    setShowSellSMSTemplates(false);
    setShowBankLawyers(false);
    setShowBankLawyersOffice(false);
    setShowCourtMailTemplates(false);
    setShowPelSub(false);
    setShowMaterials(false);
    setShowMaterialsConsultant(false);
    setShowMaterialsDepartment(false);
    setShowMaterialsConsultantDepartment(false);
    setShowMaterialsDepartmentSec(false);
    setShowSellLeadLoop(false);
    setShowSellMSAPI(false);
    setShowAddresBook(false);
    setShowPackageDesc(false);
    setShowCheckListLawsuit(false);
    setShowLetters(false);
    setShowLettersBank(false);
    setShowLettersAggr(false);
    setShowDisc(false);
    setShowBanksOld(false);
    setShowLettersLawsuit(false);
    setShowReportClients(false);
    setShowSellLeadLoopChf(false);
    setShowCheckListLawsuitSKD(false);
    setShowSupport(false);
    setShowQuestionsCHF(true);
    setShowQuestionsSKD(false);
    setShowLettersLawsuitSKD(false);
    setShowLText(false);
    setShowLTextList(false);
    setShowHearingSubject(false);
    setShowTaskLoop(false);
    setShowExpectedResults(false);
    setShowJudges(false);
    setShowJudgesK(false);
    setShowPriceList(false);
    setShowStatuses(false);
  };

  const showQUestiosnSKDF = () => {
    setShowUsers(false);
    setShowBanks(false);
    setShowCourts(false);
    setShowLawyers(false);
    setShowSubstitutes(false);
    setShowResults(false);
    setShowTasksTypes(false);
    setShowSellTasksTypes(false);
    setShowMailTemplates(false);
    setShowCountHolidays(false);
    setShowSellLeadSource(false);
    setShowSellMailTemplates(false);
    setShowSellSMSTemplates(false);
    setShowBankLawyers(false);
    setShowBankLawyersOffice(false);
    setShowCourtMailTemplates(false);
    setShowPelSub(false);
    setShowMaterials(false);
    setShowMaterialsConsultant(false);
    setShowMaterialsDepartment(false);
    setShowMaterialsConsultantDepartment(false);
    setShowMaterialsDepartmentSec(false);
    setShowSellLeadLoop(false);
    setShowSellMSAPI(false);
    setShowAddresBook(false);
    setShowPackageDesc(false);
    setShowCheckListLawsuit(false);
    setShowLetters(false);
    setShowLettersBank(false);
    setShowLettersAggr(false);
    setShowDisc(false);
    setShowBanksOld(false);
    setShowLettersLawsuit(false);
    setShowReportClients(false);
    setShowSellLeadLoopChf(false);
    setShowCheckListLawsuitSKD(false);
    setShowSupport(false);
    setShowQuestionsCHF(false);
    setShowQuestionsSKD(true);
    setShowLettersLawsuitSKD(false);
    setShowLText(false);
    setShowLTextList(false);
    setShowHearingSubject(false);
    setShowTaskLoop(false);
    setShowExpectedResults(false);
    setShowJudges(false);
    setShowJudgesK(false);
    setShowPriceList(false);
    setShowStatuses(false);
  };

  const showLTextF = () => {
    setShowUsers(false);
    setShowBanks(false);
    setShowCourts(false);
    setShowLawyers(false);
    setShowSubstitutes(false);
    setShowResults(false);
    setShowTasksTypes(false);
    setShowSellTasksTypes(false);
    setShowMailTemplates(false);
    setShowCountHolidays(false);
    setShowSellLeadSource(false);
    setShowSellMailTemplates(false);
    setShowSellSMSTemplates(false);
    setShowBankLawyers(false);
    setShowBankLawyersOffice(false);
    setShowCourtMailTemplates(false);
    setShowPelSub(false);
    setShowMaterials(false);
    setShowMaterialsConsultant(false);
    setShowMaterialsDepartment(false);
    setShowMaterialsConsultantDepartment(false);
    setShowMaterialsDepartmentSec(false);
    setShowSellLeadLoop(false);
    setShowSellMSAPI(false);
    setShowAddresBook(false);
    setShowPackageDesc(false);
    setShowCheckListLawsuit(false);
    setShowLetters(false);
    setShowLettersBank(false);
    setShowLettersAggr(false);
    setShowDisc(false);
    setShowBanksOld(false);
    setShowLettersLawsuit(false);
    setShowReportClients(false);
    setShowSellLeadLoopChf(false);
    setShowCheckListLawsuitSKD(false);
    setShowSupport(false);
    setShowQuestionsCHF(false);
    setShowQuestionsSKD(false);
    setShowLettersLawsuitSKD(false);
    setShowLText(true);
    setShowLTextList(false);
    setShowHearingSubject(false);
    setShowTaskLoop(false);
    setShowExpectedResults(false);
    setShowJudges(false);
    setShowJudgesK(false);
    setShowPriceList(false);
    setShowStatuses(false);
  };

  const showLTextListF = () => {
    setShowUsers(false);
    setShowBanks(false);
    setShowCourts(false);
    setShowLawyers(false);
    setShowSubstitutes(false);
    setShowResults(false);
    setShowTasksTypes(false);
    setShowSellTasksTypes(false);
    setShowMailTemplates(false);
    setShowCountHolidays(false);
    setShowSellLeadSource(false);
    setShowSellMailTemplates(false);
    setShowSellSMSTemplates(false);
    setShowBankLawyers(false);
    setShowBankLawyersOffice(false);
    setShowCourtMailTemplates(false);
    setShowPelSub(false);
    setShowMaterials(false);
    setShowMaterialsConsultant(false);
    setShowMaterialsDepartment(false);
    setShowMaterialsConsultantDepartment(false);
    setShowMaterialsDepartmentSec(false);
    setShowSellLeadLoop(false);
    setShowSellMSAPI(false);
    setShowAddresBook(false);
    setShowPackageDesc(false);
    setShowCheckListLawsuit(false);
    setShowLetters(false);
    setShowLettersBank(false);
    setShowLettersAggr(false);
    setShowDisc(false);
    setShowBanksOld(false);
    setShowLettersLawsuit(false);
    setShowReportClients(false);
    setShowSellLeadLoopChf(false);
    setShowCheckListLawsuitSKD(false);
    setShowSupport(false);
    setShowQuestionsCHF(false);
    setShowQuestionsSKD(false);
    setShowLettersLawsuitSKD(false);
    setShowLText(false);
    setShowLTextList(true);
    setShowHearingSubject(false);
    setShowTaskLoop(false);
    setShowExpectedResults(false);
    setShowJudges(false);
    setShowJudgesK(false);
    setShowPriceList(false);
    setShowStatuses(false);
  };

  const showHearingSubjectF = () => {
    setShowUsers(false);
    setShowBanks(false);
    setShowCourts(false);
    setShowLawyers(false);
    setShowSubstitutes(false);
    setShowResults(false);
    setShowTasksTypes(false);
    setShowSellTasksTypes(false);
    setShowMailTemplates(false);
    setShowCountHolidays(false);
    setShowSellLeadSource(false);
    setShowSellMailTemplates(false);
    setShowSellSMSTemplates(false);
    setShowBankLawyers(false);
    setShowBankLawyersOffice(false);
    setShowCourtMailTemplates(false);
    setShowPelSub(false);
    setShowMaterials(false);
    setShowMaterialsConsultant(false);
    setShowMaterialsDepartment(false);
    setShowMaterialsConsultantDepartment(false);
    setShowMaterialsDepartmentSec(false);
    setShowSellLeadLoop(false);
    setShowSellMSAPI(false);
    setShowAddresBook(false);
    setShowPackageDesc(false);
    setShowCheckListLawsuit(false);
    setShowLetters(false);
    setShowLettersBank(false);
    setShowLettersAggr(false);
    setShowDisc(false);
    setShowBanksOld(false);
    setShowLettersLawsuit(false);
    setShowReportClients(false);
    setShowSellLeadLoopChf(false);
    setShowCheckListLawsuitSKD(false);
    setShowSupport(false);
    setShowQuestionsCHF(false);
    setShowQuestionsSKD(false);
    setShowLettersLawsuitSKD(false);
    setShowLText(false);
    setShowLTextList(false);
    setShowHearingSubject(true);
    setShowTaskLoop(false);
    setShowExpectedResults(false);
    setShowJudges(false);
    setShowJudgesK(false);
    setShowPriceList(false);
    setShowStatuses(false);
  };

  const showTaskLoopF = () => {
    setShowUsers(false);
    setShowBanks(false);
    setShowCourts(false);
    setShowLawyers(false);
    setShowSubstitutes(false);
    setShowResults(false);
    setShowTasksTypes(false);
    setShowSellTasksTypes(false);
    setShowMailTemplates(false);
    setShowCountHolidays(false);
    setShowSellLeadSource(false);
    setShowSellMailTemplates(false);
    setShowSellSMSTemplates(false);
    setShowBankLawyers(false);
    setShowBankLawyersOffice(false);
    setShowCourtMailTemplates(false);
    setShowPelSub(false);
    setShowMaterials(false);
    setShowMaterialsConsultant(false);
    setShowMaterialsDepartment(false);
    setShowMaterialsConsultantDepartment(false);
    setShowMaterialsDepartmentSec(false);
    setShowSellLeadLoop(false);
    setShowSellMSAPI(false);
    setShowAddresBook(false);
    setShowPackageDesc(false);
    setShowCheckListLawsuit(false);
    setShowLetters(false);
    setShowLettersBank(false);
    setShowLettersAggr(false);
    setShowDisc(false);
    setShowBanksOld(false);
    setShowLettersLawsuit(false);
    setShowReportClients(false);
    setShowSellLeadLoopChf(false);
    setShowCheckListLawsuitSKD(false);
    setShowSupport(false);
    setShowQuestionsCHF(false);
    setShowQuestionsSKD(false);
    setShowLettersLawsuitSKD(false);
    setShowLText(false);
    setShowLTextList(false);
    setShowHearingSubject(false);
    setShowTaskLoop(true);
    setShowJudges(false);
    setShowExpectedResults(false);
    setShowJudgesK(false);
    setShowPriceList(false);
    setShowStatuses(false);
  };

  const showResultsExpectedF = () => {
    setShowUsers(false);
    setShowBanks(false);
    setShowCourts(false);
    setShowLawyers(false);
    setShowSubstitutes(false);
    setShowResults(false);
    setShowTasksTypes(false);
    setShowSellTasksTypes(false);
    setShowMailTemplates(false);
    setShowCountHolidays(false);
    setShowSellLeadSource(false);
    setShowSellMailTemplates(false);
    setShowSellSMSTemplates(false);
    setShowBankLawyers(false);
    setShowBankLawyersOffice(false);
    setShowCourtMailTemplates(false);
    setShowPelSub(false);
    setShowMaterials(false);
    setShowMaterialsConsultant(false);
    setShowMaterialsDepartment(false);
    setShowMaterialsConsultantDepartment(false);
    setShowMaterialsDepartmentSec(false);
    setShowSellLeadLoop(false);
    setShowSellMSAPI(false);
    setShowAddresBook(false);
    setShowPackageDesc(false);
    setShowCheckListLawsuit(false);
    setShowLetters(false);
    setShowLettersBank(false);
    setShowLettersAggr(false);
    setShowDisc(false);
    setShowBanksOld(false);
    setShowLettersLawsuit(false);
    setShowReportClients(false);
    setShowSellLeadLoopChf(false);
    setShowCheckListLawsuitSKD(false);
    setShowSupport(false);
    setShowQuestionsCHF(false);
    setShowQuestionsSKD(false);
    setShowLettersLawsuitSKD(false);
    setShowLText(false);
    setShowLTextList(false);
    setShowHearingSubject(false);
    setShowTaskLoop(false);
    setShowExpectedResults(true);
    setShowJudges(false);
    setShowJudgesK(false);
    setShowPriceList(false);
    setShowStatuses(false);
  };

  const showJudgesF = () => {
    setShowUsers(false);
    setShowBanks(false);
    setShowCourts(false);
    setShowLawyers(false);
    setShowSubstitutes(false);
    setShowResults(false);
    setShowTasksTypes(false);
    setShowSellTasksTypes(false);
    setShowMailTemplates(false);
    setShowCountHolidays(false);
    setShowSellLeadSource(false);
    setShowSellMailTemplates(false);
    setShowSellSMSTemplates(false);
    setShowBankLawyers(false);
    setShowBankLawyersOffice(false);
    setShowCourtMailTemplates(false);
    setShowPelSub(false);
    setShowMaterials(false);
    setShowMaterialsConsultant(false);
    setShowMaterialsDepartment(false);
    setShowMaterialsConsultantDepartment(false);
    setShowMaterialsDepartmentSec(false);
    setShowSellLeadLoop(false);
    setShowSellMSAPI(false);
    setShowAddresBook(false);
    setShowPackageDesc(false);
    setShowCheckListLawsuit(false);
    setShowLetters(false);
    setShowLettersBank(false);
    setShowLettersAggr(false);
    setShowDisc(false);
    setShowBanksOld(false);
    setShowLettersLawsuit(false);
    setShowReportClients(false);
    setShowSellLeadLoopChf(false);
    setShowCheckListLawsuitSKD(false);
    setShowSupport(false);
    setShowQuestionsCHF(false);
    setShowQuestionsSKD(false);
    setShowLettersLawsuitSKD(false);
    setShowLText(false);
    setShowLTextList(false);
    setShowHearingSubject(false);
    setShowTaskLoop(false);
    setShowExpectedResults(false);
    setShowJudges(true);
    setShowJudgesK(false);
    setShowPriceList(false);
    setShowStatuses(false);
  };

  const showJudgesKF = () => {
    setShowUsers(false);
    setShowBanks(false);
    setShowCourts(false);
    setShowLawyers(false);
    setShowSubstitutes(false);
    setShowResults(false);
    setShowTasksTypes(false);
    setShowSellTasksTypes(false);
    setShowMailTemplates(false);
    setShowCountHolidays(false);
    setShowSellLeadSource(false);
    setShowSellMailTemplates(false);
    setShowSellSMSTemplates(false);
    setShowBankLawyers(false);
    setShowBankLawyersOffice(false);
    setShowCourtMailTemplates(false);
    setShowPelSub(false);
    setShowMaterials(false);
    setShowMaterialsConsultant(false);
    setShowMaterialsDepartment(false);
    setShowMaterialsConsultantDepartment(false);
    setShowMaterialsDepartmentSec(false);
    setShowSellLeadLoop(false);
    setShowSellMSAPI(false);
    setShowAddresBook(false);
    setShowPackageDesc(false);
    setShowCheckListLawsuit(false);
    setShowLetters(false);
    setShowLettersBank(false);
    setShowLettersAggr(false);
    setShowDisc(false);
    setShowBanksOld(false);
    setShowLettersLawsuit(false);
    setShowReportClients(false);
    setShowSellLeadLoopChf(false);
    setShowCheckListLawsuitSKD(false);
    setShowSupport(false);
    setShowQuestionsCHF(false);
    setShowQuestionsSKD(false);
    setShowLettersLawsuitSKD(false);
    setShowLText(false);
    setShowLTextList(false);
    setShowHearingSubject(false);
    setShowTaskLoop(false);
    setShowExpectedResults(false);
    setShowJudges(false);
    setShowJudgesK(true);
    setShowPriceList(false);
    setShowStatuses(false);
  };

  const showPriceListF = () => {
    setShowUsers(false);
    setShowBanks(false);
    setShowCourts(false);
    setShowLawyers(false);
    setShowSubstitutes(false);
    setShowResults(false);
    setShowTasksTypes(false);
    setShowSellTasksTypes(false);
    setShowMailTemplates(false);
    setShowCountHolidays(false);
    setShowSellLeadSource(false);
    setShowSellMailTemplates(false);
    setShowSellSMSTemplates(false);
    setShowBankLawyers(false);
    setShowBankLawyersOffice(false);
    setShowCourtMailTemplates(false);
    setShowPelSub(false);
    setShowMaterials(false);
    setShowMaterialsConsultant(false);
    setShowMaterialsDepartment(false);
    setShowMaterialsConsultantDepartment(false);
    setShowMaterialsDepartmentSec(false);
    setShowSellLeadLoop(false);
    setShowSellMSAPI(false);
    setShowAddresBook(false);
    setShowPackageDesc(false);
    setShowCheckListLawsuit(false);
    setShowLetters(false);
    setShowLettersBank(false);
    setShowLettersAggr(false);
    setShowDisc(false);
    setShowBanksOld(false);
    setShowLettersLawsuit(false);
    setShowReportClients(false);
    setShowSellLeadLoopChf(false);
    setShowCheckListLawsuitSKD(false);
    setShowSupport(false);
    setShowQuestionsCHF(false);
    setShowQuestionsSKD(false);
    setShowLettersLawsuitSKD(false);
    setShowLText(false);
    setShowLTextList(false);
    setShowHearingSubject(false);
    setShowTaskLoop(false);
    setShowExpectedResults(false);
    setShowJudges(false);
    setShowJudgesK(false);
    setShowPriceList(true);
    setShowStatuses(false);
  };

  const showStatusesF = () => {
    setShowUsers(false);
    setShowBanks(false);
    setShowCourts(false);
    setShowLawyers(false);
    setShowSubstitutes(false);
    setShowResults(false);
    setShowTasksTypes(false);
    setShowSellTasksTypes(false);
    setShowMailTemplates(false);
    setShowCountHolidays(false);
    setShowSellLeadSource(false);
    setShowSellMailTemplates(false);
    setShowSellSMSTemplates(false);
    setShowBankLawyers(false);
    setShowBankLawyersOffice(false);
    setShowCourtMailTemplates(false);
    setShowPelSub(false);
    setShowMaterials(false);
    setShowMaterialsConsultant(false);
    setShowMaterialsDepartment(false);
    setShowMaterialsConsultantDepartment(false);
    setShowMaterialsDepartmentSec(false);
    setShowSellLeadLoop(false);
    setShowSellMSAPI(false);
    setShowAddresBook(false);
    setShowPackageDesc(false);
    setShowCheckListLawsuit(false);
    setShowLetters(false);
    setShowLettersBank(false);
    setShowLettersAggr(false);
    setShowDisc(false);
    setShowBanksOld(false);
    setShowLettersLawsuit(false);
    setShowReportClients(false);
    setShowSellLeadLoopChf(false);
    setShowCheckListLawsuitSKD(false);
    setShowSupport(false);
    setShowQuestionsCHF(false);
    setShowQuestionsSKD(false);
    setShowLettersLawsuitSKD(false);
    setShowLText(false);
    setShowLTextList(false);
    setShowHearingSubject(false);
    setShowTaskLoop(false);
    setShowExpectedResults(false);
    setShowJudges(false);
    setShowJudgesK(false);
    setShowPriceList(false);
    setShowStatuses(true);
  };

  return (
    <>
      <div className="mainContainerPayments">
        <div
          style={{ width: "100%", marginBottom: "1vh" }}
          className="closeBox"
        >
          <button className="closeClientButton" onClick={props.close}>
            X
          </button>
        </div>
        <div className="paymentMenuContainer">
          <button className="paymentMenuButton" onClick={showUsersF}>
            Użytkownicy
          </button>
          <button className="paymentMenuButton" onClick={showCountHolidaysF}>
            Urlopy
          </button>
          <button className="paymentMenuButton" onClick={showBanksF}>
            Banki
          </button>
          <button className="paymentMenuButton" onClick={showCourtsF}>
            Sądy
          </button>
          <button className="paymentMenuButton" onClick={showLawyersF}>
            Prawnicy
          </button>
          <button className="paymentMenuButton" onClick={showSubstitutesF}>
            Substytuci
          </button>
          <button className="paymentMenuButton" onClick={showPelSubF}>
            Pełnomocnicy Substytucyjni
          </button>
          <button className="paymentMenuButton" onClick={showBankLawyersF}>
            Pełnomocnicy banków
          </button>
          <button
            className="paymentMenuButton"
            onClick={showBankLawyersOfficeF}
          >
            Kancelarie pełnomocników banków
          </button>
          <button className="paymentMenuButton" onClick={showResultsF}>
            Wyniki rozpraw
          </button>
          <button className="paymentMenuButton" onClick={showResultsExpectedF}>
            Wyniki rozpraw - oczekiwane
          </button>
          <button className="paymentMenuButton" onClick={showTasksTypesF}>
            Rodzaje zadań
          </button>
          <button className="paymentMenuButton" onClick={showSellTasksTypesF}>
            Rodzaje zadań - sprzedaż
          </button>
          <button className="paymentMenuButton" onClick={showSellLeadSourceF}>
            Źródła leadów - sprzedaż
          </button>
          <button className="paymentMenuButton" onClick={showMailTemplatesF}>
            Szablony maili
          </button>
          <button
            className="paymentMenuButton"
            onClick={showSellMailTemplatesF}
          >
            Szablony maili - sprzedaż
          </button>
          <button
            className="paymentMenuButton"
            onClick={showSellCourtMailTemplatesF}
          >
            Szablony maili - sądy
          </button>
          <button className="paymentMenuButton" onClick={showSellSMSTemplatesF}>
            Szablony sms - sprzedaż
          </button>
          <button className="paymentMenuButton" onClick={showMaterialsF}>
            Materiały
          </button>
          <button
            className="paymentMenuButton"
            onClick={showMaterialsDepartmentF}
          >
            Materiały - DZIAŁY
          </button>
          <button
            className="paymentMenuButton"
            onClick={showMaterialsDepartmentSecF}
          >
            Materiały - DZIAŁY - poziom drugi
          </button>
          <button className="paymentMenuButton" onClick={showResultSubF}>
            Wyroki - zastępcy w zadaniach
          </button>
          <button className="paymentMenuButton" onClick={showSellLeadLoopF}>
            Kolejka - leady SKD
          </button>
          <button className="paymentMenuButton" onClick={showLeadLoopChfF}>
            Kolejka - leady CHF
          </button>
          <button className="paymentMenuButton" onClick={showSellMSAPIF}>
            TESTY - PORTAL INFORMACYJNY
          </button>
          <button className="paymentMenuButton" onClick={showAddressBookF}>
            KSIĄŻKA ADRESOWA
          </button>
          <button className="paymentMenuButton" onClick={showPackageDescF}>
            OPISY PRZESYŁEK
          </button>
          <button
            className="paymentMenuButton"
            onClick={showPChecklistLawsuitF}
          >
            CHECKLISTA DLA POZWÓW
          </button>
          <button
            className="paymentMenuButton"
            onClick={showCheckListLawsuitSKDF}
          >
            CHECKLISTA DLA POZWÓW SKD
          </button>
          <button className="paymentMenuButton" onClick={showLettersF}>
            PISMA GENEROWANE AUTOMATYCZNIE
          </button>
          <button className="paymentMenuButton" onClick={showLettersBankF}>
            WEZWANIA GENEROWANE AUTOMATYCZNIE
          </button>
          <button className="paymentMenuButton" onClick={showLettersAggrF}>
            UMOWY GENEROWANE AUTOMATYCZNIE
          </button>
          <button className="paymentMenuButton" onClick={showDiscF}>
            ZAJĘTA POWIERZCHNIA DYSKOWA
          </button>
          <button className="paymentMenuButton" onClick={showBanksOldF}>
            PODMIOTY Z UMOWY KREDYTOWEJ
          </button>
          <button className="paymentMenuButton" onClick={showLettersLawsuitF}>
            POZWY GENEROWANE AUTOMATYCZNIE CHF
          </button>
          <button
            className="paymentMenuButton"
            onClick={showLettersLawsuitSKDF}
          >
            POZWY GENEROWANE AUTOMATYCZNIE SKD
          </button>
          <button className="paymentMenuButton" onClick={showReportClientsF}>
            RAPORT - BRAK OSOBY ODPOWIEDZIALNEJ ZA POZEW
          </button>
          <button className="paymentMenuButton" onClick={showSupportF}>
            TEMATY WSPARCIA
          </button>
          <button className="paymentMenuButton" onClick={showQUestiosnCHFF}>
            PYTANIA DO ANKIETY CHF
          </button>
          <button className="paymentMenuButton" onClick={showQUestiosnSKDF}>
            PYTANIA DO ANKIETY SKD
          </button>
          <button className="paymentMenuButton" onClick={showLTextF}>
            ELEMENTY POZWU
          </button>
          <button className="paymentMenuButton" onClick={showLTextListF}>
            ELEMENTY POZWU - LISTY
          </button>
          <button className="paymentMenuButton" onClick={showHearingSubjectF}>
            PRZEDMIOTY ROZPRAW
          </button>
          <button className="paymentMenuButton" onClick={showTaskLoopF}>
            GRUPY DO ZADAŃ
          </button>
          <button className="paymentMenuButton" onClick={showJudgesF}>
            SĘDZIOWIE
          </button>
          <button className="paymentMenuButton" onClick={showJudgesKF}>
            SĘDZIOWIE (KZP w pełnej wysokości)
          </button>
          <button className="paymentMenuButton" onClick={showPriceListF}>
            CENY LEADÓW
          </button>

          <button className="paymentMenuButton" onClick={showStatusesF}>
            STATUSY SPRAW
          </button>
        </div>
        {showUsers ||
        (!showBanks &&
          !showCourts &&
          !showLawyers &&
          !showSubstitutes &&
          !showResults &&
          !showTasksTypes &&
          !showSellTasksTypes &&
          !showSellLeadSource &&
          !showMailTemplates &&
          !showSellMailTemplates &&
          !showSellSMSTemplates &&
          !showCountHolidays &&
          !showBankLawyers &&
          !showBankLawyersOffice &&
          !showCourtMailTemplates &&
          !showPelSub &&
          !showMaterials &&
          !showMaterialsConsultant &&
          !showMaterialsDepartment &&
          !showMaterialsDepartmentSec &&
          !showMaterialsConsultantDepartment &&
          !showResultSub &&
          !showSellLeadLoop &&
          !showSellMSAPI &&
          !showAddressBook &&
          !showPackageDesc &&
          !showCheckListLawsuit &&
          !showLetters &&
          !showLettersBank &&
          !showLettersAggr &&
          !showDisc &&
          !showBanksOld &&
          !showLettersLawsuit &&
          !showLettersLawsuitSKD &&
          !showReportClients &&
          !showLeadLoopChfF &&
          !showCheckListLawsuitSKD &&
          !showSupportF &&
          !showQuestuonsCHF &&
          !showQuestuonsSKD &&
          !showLText &&
          !showLTextList &&
          !showHearingSubject &&
          !showTaskLoop &&
          !showExpectedResults &&
          !showJudges) ? (
          <>
            <AdminPanelUsers />
          </>
        ) : showBanks ? (
          <>
            <AdminPanelBanks
              close={() => {
                setShowBanks(false);
              }}
            />
          </>
        ) : showTaskLoop ? (
          <>
            <AdminPanelLoopTasks
              close={() => {
                setShowTaskLoop(false);
              }}
            />
          </>
        ) : showExpectedResults ? (
          <>
            <AdminPanelExpectedResults
              close={() => {
                setShowExpectedResults(false);
              }}
            />
          </>
        ) : showBanksOld ? (
          <>
            <AdminPanelBanksOld
              close={() => {
                setShowBanksOld(false);
              }}
            />
          </>
        ) : showCourts ? (
          <>
            <AdminPanelCourts
              close={() => {
                setShowCourts(false);
              }}
            />
          </>
        ) : showSupport ? (
          <>
            <AdminPanelSupport
              close={() => {
                setShowSupport(false);
              }}
            />
          </>
        ) : showLawyers ? (
          <>
            <AdminPanelLawyers
              close={() => {
                setShowLawyers(false);
              }}
            />
          </>
        ) : showDisc ? (
          <>
            <AdminPanelDisc
              close={() => {
                setShowDisc(false);
              }}
            />
          </>
        ) : showHearingSubject ? (
          <>
            <AdminPanelHearingSubject
              close={() => {
                setShowHearingSubject(false);
              }}
            />
          </>
        ) : showJudges ? (
          <>
            <AdminPanelJudges
              close={() => {
                setShowJudges(false);
              }}
            />
          </>
        ) : showJudgesK ? (
          <>
            <AdminPanelJudgesK
              close={() => {
                setShowJudgesK(false);
              }}
            />
          </>
        ) : showReportClients ? (
          <>
            <AdminPanelReportClients
              close={() => {
                setShowReportClients(false);
              }}
            />
          </>
        ) : showCheckListLawsuit ? (
          <>
            <AdminPanelChecklistLawsuit
              close={() => {
                setShowCheckListLawsuit(false);
              }}
            />
          </>
        ) : showCheckListLawsuitSKD ? (
          <>
            <AdminPanelChecklistLawsuitSKD
              close={() => {
                setShowCheckListLawsuitSKD(false);
              }}
            />
          </>
        ) : showAddressBook ? (
          <>
            <AdminPanelAddressBook
              close={() => {
                setShowAddresBook(false);
              }}
            />
          </>
        ) : showLetters ? (
          <>
            <AdminPanelLetters
              close={() => {
                setShowLetters(false);
              }}
            />
          </>
        ) : showLettersBank ? (
          <>
            <AdminPanelLettersBank
              close={() => {
                setShowLettersBank(false);
              }}
            />
          </>
        ) : showLettersLawsuit ? (
          <>
            <AdminPanelLettersLawsuit
              close={() => {
                setShowLettersLawsuit(false);
              }}
            />
          </>
        ) : showLettersLawsuitSKD ? (
          <>
            <AdminPanelLettersLawsuitSKD
              close={() => {
                setShowLettersLawsuitSKD(false);
              }}
            />
          </>
        ) : showLettersAggr ? (
          <>
            <AdminPanelLettersAggr
              close={() => {
                setShowLettersAggr(false);
              }}
            />
          </>
        ) : showSubstitutes ? (
          <>
            <AdminPanelSubstitutes
              close={() => {
                setShowSubstitutes(false);
              }}
            />
          </>
        ) : showPackageDesc ? (
          <>
            <AdminPanelPackageDesc
              close={() => {
                setShowPackageDesc(false);
              }}
            />
          </>
        ) : showPelSub ? (
          <>
            <AdminPanelPelSubLawyers
              close={() => {
                setShowPelSub(false);
              }}
            />
          </>
        ) : showSellLeadSource ? (
          <>
            <AdminPanelLeadSources
              close={() => {
                setShowSellLeadSource(false);
              }}
            />
          </>
        ) : showSellMSAPI ? (
          <>
            <AdminPanelMSAPI
              close={() => {
                setShowSellMSAPI(false);
              }}
            />
          </>
        ) : showSellLeadLoop ? (
          <>
            <AdminPanelLeadsLoop
              close={() => {
                setShowSellLeadLoop(false);
              }}
            />
          </>
        ) : showSellLeadLoopChf ? (
          <>
            <AdminPanelLeadsLoopChf
              close={() => {
                setShowSellLeadLoopChf(false);
              }}
            />
          </>
        ) : showResults ? (
          <>
            <AdminPanelResults
              close={() => {
                setShowResults(false);
              }}
            />
          </>
        ) : showMaterials ? (
          <>
            <AdminPanelMaterials
              close={() => {
                setShowMaterials(false);
              }}
              user={props.user}
            />
          </>
        ) : showMaterialsConsultant ? (
          <>
            <AdminPanelMaterialsConsultant
              close={() => {
                setShowMaterialsConsultant(false);
              }}
            />
          </>
        ) : showMaterialsDepartment ? (
          <>
            <AdminPanelMaterialsDepartment
              close={() => {
                setShowMaterialsDepartment(false);
              }}
            />
          </>
        ) : showMaterialsDepartmentSec ? (
          <>
            <AdminPanelMaterialsDepartmentSec
              close={() => {
                setShowMaterialsDepartmentSec(false);
              }}
            />
          </>
        ) : showMaterialsConsultantDepartment ? (
          <>
            <AdminPanelMaterialsConsultantDepartment
              close={() => {
                setShowMaterialsConsultantDepartment(false);
              }}
            />
          </>
        ) : showTasksTypes ? (
          <>
            <AdminPanelTaskTypes
              close={() => {
                setShowTasksTypes(false);
              }}
            />
          </>
        ) : showSellTasksTypes ? (
          <>
            <AdminPanelSellTaskTypes
              close={() => {
                setShowSellTasksTypes(false);
              }}
            />
          </>
        ) : showMailTemplates ? (
          <>
            <AdminPanelMailTemplate
              close={() => {
                setShowMailTemplates(false);
              }}
            />
          </>
        ) : showCourtMailTemplates ? (
          <>
            <AdminPanelCourtMailTemplate
              close={() => {
                setShowCourtMailTemplates(false);
              }}
            />
          </>
        ) : showResultSub ? (
          <>
            <AdminPanelUsersResults
              close={() => {
                setShowResultSub(false);
              }}
            />
          </>
        ) : showSellMailTemplates ? (
          <>
            <AdminPanelSellMailTemplate
              close={() => {
                setShowSellMailTemplates(false);
              }}
            />
          </>
        ) : showSellSMSTemplates ? (
          <>
            <AdminPanelSellSMSTemplate
              close={() => {
                setShowSellSMSTemplates(false);
              }}
            />
          </>
        ) : showBankLawyers ? (
          <>
            <AdminPanelBankLawyers
              close={() => {
                setShowBankLawyers(false);
              }}
            />
          </>
        ) : showQuestuonsCHF ? (
          <>
            <AdminPanelQuestionsCHF
              close={() => {
                setShowQuestionsCHF(false);
              }}
            />
          </>
        ) : showQuestuonsSKD ? (
          <>
            <AdminPanelQuestionsSKD
              close={() => {
                setShowQuestionsSKD(false);
              }}
            />
          </>
        ) : showBankLawyersOffice ? (
          <>
            <AdminPanelBankLawyersOffice
              close={() => {
                setShowBankLawyersOffice(false);
              }}
            />
          </>
        ) : showLText ? (
          <>
            <AdminPanelLawsuitText
              close={() => {
                setShowLText(false);
              }}
            />
          </>
        ) : showLTextList ? (
          <>
            <AdminPanelLawsuitTextList
              close={() => {
                setShowLTextList(false);
              }}
            />
          </>
        ) : showCountHolidays ? (
          <>
            <AdminPanelHolidays
              close={() => {
                setShowCountHolidays(false);
              }}
            />
          </>
        ) : showPriceList ? (
          <>
            <AdminPanelLeadsPriceList
              close={() => {
                setShowPriceList(false);
              }}
            />
          </>
        ) : showStatuses ? (
          <>
            <AdminPanelStatuses
              close={() => {
                setShowStatuses(false);
              }}
            />
          </>
        ) : (
          ""
        )}
      </div>
    </>
  );
};

export default AdminPanel;
